<template>

  <section class="section about">

    <div class="prices-header has-text-centered">
      <img src="../assets/find_workout.svg" alt=""></img><br><br>
    </div>


    <div class="columns is-centered">

      <!-- STUDIO SELECTOR -->
      <div class="dropdown" id="explore-dropdown-button-container" @click="activateStudioDropdown()" :class="{'is-active' : studioDropdown}">
        <div class="dropdown-trigger">
          <button  id="workout-explore-dropdown" class="button" aria-haspopup="true" aria-controls="dropdown-menu" :class="{'is-success' : dropdownIsSelected('studio')}">
            <span>{{dropdownStudioName}}</span>
            <span class="icon is-small">
              <i class="fas fa-angle-down" aria-hidden="true"></i>
            </span>
          </button>
        </div>
        <div class="dropdown-menu" id="dropdown-menu" role="menu">
          <div class="dropdown-content">
            <a @click="setActiveStudio('all')" class="dropdown-item">
              Se alle
            </a>
            <a @click="setActiveStudio('Shankha')" class="dropdown-item">
              Shankha Yoga
            </a>
            <a @click="setActiveStudio('Yogaens Hus')" class="dropdown-item">
              Yogaens Hus
            </a>
            <a @click="setActiveStudio('Pilates Trondheim')" class="dropdown-item">
              Pilates Trondheim
            </a>
            <a @click="setActiveStudio('Fitness Point')" class="dropdown-item">
              Fitness Point
            </a>
            <a @click="setActiveStudio('Heimdal Klatresenter')" class="dropdown-item">
              Heimdal Klatresenter
            </a>
            <a @click="setActiveStudio('Terra Yoga')" class="dropdown-item">
              Terra Yoga
            </a>
            <a @click="setActiveStudio('Trondheim Kickboksing')" class="dropdown-item">
              Trondheim Kickboksing
            </a>
          </div>
        </div>
      </div>

      <!--TYPE SELECTOR -->
      <div class="dropdown" id="explore-dropdown-button-container" @click="activateTypeDropdown()" :class="{'is-active' : typeDropdown}">
        <div class="dropdown-trigger">
          <button id="workout-explore-dropdown" class="button" aria-haspopup="true" aria-controls="dropdown-menu" :class="{'is-success' : dropdownIsSelected('type')}">
            <span>{{dropdownTypeName}}</span>
            <span class="icon is-small">
              <i class="fas fa-angle-down" aria-hidden="true"></i>
            </span>
          </button>
        </div>
        <div class="dropdown-menu" id="dropdown-menu" role="menu">
          <div class="dropdown-content">
            <a @click="setActive('all')" class="dropdown-item">
              Se alle
            </a>
            <a @click="setActive('Yoga')" class="dropdown-item">
              Yoga
            </a>
            <a @click="setActive('Pilates')" class="dropdown-item">
              Pilates
            </a>
            <a @click="setActive('Kondisjon')" class="dropdown-item">
              Kondisjon
            </a>
            <a @click="setActive('Klatring')" class="dropdown-item">
              Klatring
            </a>

          </div>
        </div>
      </div>

    </div>

<!--END DAYS TABS-->

<!-- Delete Class Modal -->
<div class="modal" :class="{ 'is-active': showDeleteModal}">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Er du sikker på at du ønsker å slette timen?</p>
      <button class="delete" @click="showDeleteModal = false" aria-label="close"></button>
    </header>
    <section class="modal-card-body">
      <p>Dersom du sletter timen, vil alle deltakere bli fjernet. Det er ikke mulig å gjenopprette timen.</p>
    </section>
    <footer class="modal-card-foot">
      <button class="button is-danger" @click="deleteClass()">Ja, slett timen</button>
      <button class="button" @click="showDeleteModal = false">Avbryt</button>
    </footer>
  </div>
</div>




<div class="container taster-dates" id="classes">

  <!-- First Week -->
  <div v-if="isActiveWeek('firstWeek')" class="tabs is-centered dates">
    <ul>
      <div @click="previousWeek()" class="button" id="btn-weeks" v-bind:html="{ 'disabled': isActiveWeek('firstWeek')}"><i class="fas fa-angle-left fa-lg"></i> </div>
      <li class ="has-text-centered workout-date" @click="setActiveDay('Mandag')" :class="{ 'is-active': isActiveDay('Mandag')}"><a>{{ dateNumber }}<br>{{ day }}</a></li>
      <li class ="has-text-centered workout-date" @click="setActiveDay('Tirsdag')" :class="{ 'is-active': isActiveDay('Tirsdag')}"><a>{{ dateNumberTomorrow }}<br>{{ dayTomorrow }}</a></li>
      <li class ="has-text-centered workout-date" @click="setActiveDay('Onsdag')" :class="{ 'is-active': isActiveDay('Onsdag')}"><a>{{ dateNumberThirdday }}<br>{{ dayThirdday }}</a></li>
      <li class ="has-text-centered workout-date" @click="setActiveDay('Torsdag')" :class="{ 'is-active': isActiveDay('Torsdag')}"><a>{{ dateNumberFourthday }}<br>{{ dayFourthday }}</a></li>
      <li class ="has-text-centered workout-date" @click="setActiveDay('Fredag')" :class="{ 'is-active': isActiveDay('Fredag')}"><a>{{ dateNumberFifthday }}<br>{{ dayFifthday }}</a></li>
      <li class ="has-text-centered workout-date" @click="setActiveDay('Lørdag')" :class="{ 'is-active': isActiveDay('Lørdag')}"><a>{{ dateNumberSixthday }}<br>{{ daySixthday }}</a></li>
      <li class ="has-text-centered workout-date" @click="setActiveDay('Søndag')" :class="{ 'is-active': isActiveDay('Søndag')}"><a>{{ dateNumberSeventhday }}<br>{{ daySeventhday }}</a></li>
      <div @click="nextWeek()" class="button" id="btn-weeks"><i class="fas fa-angle-right fa-lg"></i></div>
    </ul>
  </div>

  <!-- Second Week -->
  <div v-if="isActiveWeek('secondWeek')" class="tabs is-centered dates">
    <ul>
      <div @click="previousWeek()" class="button" id="btn-weeks"><i class="fas fa-angle-left fa-lg"></i> </div>
      <li class ="has-text-centered workout-date" @click="setActiveDay('sw_Mandag')" :class="{ 'is-active': isActiveDay('sw_Mandag')}"><a>{{ sw_dateNumber }}<br>{{ sw_day }}</a></li>
      <li class ="has-text-centered workout-date" @click="setActiveDay('sw_Tirsdag')" :class="{ 'is-active': isActiveDay('sw_Tirsdag')}"><a>{{ sw_dateNumberTomorrow }}<br>{{ sw_dayTomorrow }}</a></li>
      <li class ="has-text-centered workout-date" @click="setActiveDay('sw_Onsdag')" :class="{ 'is-active': isActiveDay('sw_Onsdag')}"><a>{{ sw_dateNumberThirdday }}<br>{{ sw_dayThirdday }}</a></li>
      <li class ="has-text-centered workout-date" @click="setActiveDay('sw_Torsdag')" :class="{ 'is-active': isActiveDay('sw_Torsdag')}"><a>{{ sw_dateNumberFourthday }}<br>{{ sw_dayFourthday }}</a></li>
      <li class ="has-text-centered workout-date" @click="setActiveDay('sw_Fredag')" :class="{ 'is-active': isActiveDay('sw_Fredag')}"><a>{{ sw_dateNumberFifthday }}<br>{{ sw_dayFifthday }}</a></li>
      <li class ="has-text-centered workout-date" @click="setActiveDay('sw_Lørdag')" :class="{ 'is-active': isActiveDay('sw_Lørdag')}"><a>{{ sw_dateNumberSixthday }}<br>{{ sw_daySixthday }}</a></li>
      <li class ="has-text-centered workout-date" @click="setActiveDay('sw_Søndag')" :class="{ 'is-active': isActiveDay('sw_Søndag')}"><a>{{ sw_dateNumberSeventhday }}<br>{{ sw_daySeventhday }}</a></li>
      <div @click="nextWeek()" class="button" id="btn-weeks"><i class="fas fa-angle-right fa-lg"></i></div>
    </ul>
  </div>

  <!-- Third Week -->
  <div v-if="isActiveWeek('thirdWeek')" class="tabs is-centered dates">
    <ul>
      <div @click="previousWeek()" class="button" id="btn-weeks"><i class="fas fa-angle-left fa-lg"></i> </div>
      <li class ="has-text-centered workout-date" @click="setActiveDay('tw_Mandag')" :class="{ 'is-active': isActiveDay('tw_Mandag')}"><a>{{ tw_dateNumber }}<br>{{ tw_day }}</a></li>
      <li class ="has-text-centered workout-date" @click="setActiveDay('tw_Tirsdag')" :class="{ 'is-active': isActiveDay('tw_Tirsdag')}"><a>{{ tw_dateNumberTomorrow }}<br>{{ tw_dayTomorrow }}</a></li>
      <li class ="has-text-centered workout-date" @click="setActiveDay('tw_Onsdag')" :class="{ 'is-active': isActiveDay('tw_Onsdag')}"><a>{{ tw_dateNumberThirdday }}<br>{{ tw_dayThirdday }}</a></li>
      <li class ="has-text-centered workout-date" @click="setActiveDay('tw_Torsdag')" :class="{ 'is-active': isActiveDay('tw_Torsdag')}"><a>{{ tw_dateNumberFourthday }}<br>{{ tw_dayFourthday }}</a></li>
      <li class ="has-text-centered workout-date" @click="setActiveDay('tw_Fredag')" :class="{ 'is-active': isActiveDay('tw_Fredag')}"><a>{{ tw_dateNumberFifthday }}<br>{{ tw_dayFifthday }}</a></li>
      <li class ="has-text-centered workout-date" @click="setActiveDay('tw_Lørdag')" :class="{ 'is-active': isActiveDay('tw_Lørdag')}"><a>{{ tw_dateNumberSixthday }}<br>{{ tw_daySixthday }}</a></li>
      <li class ="has-text-centered workout-date" @click="setActiveDay('tw_Søndag')" :class="{ 'is-active': isActiveDay('tw_Søndag')}"><a>{{ tw_dateNumberSeventhday }}<br>{{ tw_daySeventhday }}</a></li>
      <div @click="nextWeek()" class="button" id="btn-weeks"><i class="fas fa-angle-right fa-lg"></i></div>
    </ul>
  </div>

  <!-- Fourth Week -->
  <div v-if="isActiveWeek('fourthWeek')" class="tabs is-centered dates">
    <ul>
      <div @click="previousWeek()" class="button" id="btn-weeks"><i class="fas fa-angle-left fa-lg"></i> </div>
      <li class ="has-text-centered workout-date" @click="setActiveDay('fw_Mandag')" :class="{ 'is-active': isActiveDay('fw_Mandag')}"><a>{{ fw_dateNumber }}<br>{{ fw_day }}</a></li>
      <li class ="has-text-centered workout-date" @click="setActiveDay('fw_Tirsdag')" :class="{ 'is-active': isActiveDay('fw_Tirsdag')}"><a>{{ fw_dateNumberTomorrow }}<br>{{ fw_dayTomorrow }}</a></li>
      <li class ="has-text-centered workout-date" @click="setActiveDay('fw_Onsdag')" :class="{ 'is-active': isActiveDay('fw_Onsdag')}"><a>{{ fw_dateNumberThirdday }}<br>{{ fw_dayThirdday }}</a></li>
      <li class ="has-text-centered workout-date" @click="setActiveDay('fw_Torsdag')" :class="{ 'is-active': isActiveDay('fw_Torsdag')}"><a>{{ fw_dateNumberFourthday }}<br>{{ fw_dayFourthday }}</a></li>
      <li class ="has-text-centered workout-date" @click="setActiveDay('fw_Fredag')" :class="{ 'is-active': isActiveDay('fw_Fredag')}"><a>{{ fw_dateNumberFifthday }}<br>{{ fw_dayFifthday }}</a></li>
      <li class ="has-text-centered workout-date" @click="setActiveDay('fw_Lørdag')" :class="{ 'is-active': isActiveDay('fw_Lørdag')}"><a>{{ fw_dateNumberSixthday }}<br>{{ fw_daySixthday }}</a></li>
      <li class ="has-text-centered workout-date" @click="setActiveDay('fw_Søndag')" :class="{ 'is-active': isActiveDay('fw_Søndag')}"><a>{{ fw_dateNumberSeventhday }}<br>{{ fw_daySeventhday }}</a></li>
      <div @click="nextWeek()" class="button" id="btn-weeks"><i class="fas fa-angle-right fa-lg"></i></div>
    </ul>
  </div>

</div>



<!-- WORKOUT TABLE -->
<div class="container" id="workout-explore-container">

  <div class="columns is-centered" id="explore-column">

    <div class="column"  id="workout-time-hd">
      <td>Tidspunkt</td>
    </div>
    <div class="column" id="workout-duration-hd">
      <td>Varighet</td>
    </div>
    <div class="column" id="workout-name-hd">
      <h1>Time</h1>
    </div>
    <div class="column" id="workout-studio-hd">
      <h1>Sted</h1>
    </div>
    <div class="column" id="workout-type-hd">
      <td>Type</td>
    </div>
    <div class="column" id="workout-places">
      <td></td>
    </div>
    <div class="column" id="workout-book">
      <td id="workout-book-2"></td>
    </div>

  </div>
<!--FIRST WEEK -->
  <!-- FIRST DAY -->
  <div class="container" id="explore-container" v-for="(workout, index) in workouts_sorted_time" v-if="(today(workout) && activeDay === 'Mandag') && ((activeType === workout.type || activeType === 'all') && (activeStudio === workout.studio.name || activeStudio === 'all'))">
    <a @click="launchActiveWorkout(workout)" class="columns is-centered" id="explore-column">

      <div class="column"  id="workout-time">
        <th>{{workout.time}}</th>
      </div>
      <div class="column" id="workout-duration">
        <td>{{workout.duration}} min</td>
      </div>
      <div class="column" id="workout-name">
        <h1><a @click="launchActiveWorkout(workout)" id="workout-name-a">{{workout.name}}</a></h1>
      </div>
      <div class="column" id="workout-studio">
        <h1>{{workout.studio.name}}</h1>
      </div>
      <div class="column" id="workout-type">
        <td>{{workout.type}}</td>
      </div>
      <div class="column" id="workout-places">
        <td>Ledige plasser: {{workout.places_left}}</td>
      </div>
      <div class="column" id="workout-book">
        <td id="workout-book-2"><button v-if="!isAttending(workout) && workout.places_left != 0" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon">Book time</button></td>
        <td id="workout-book-2"><button v-if="isAttending(workout)" disabled class="button" id="pameld">Påmeldt</button></td> <td id="workout-book-2"><button v-if="workout.places_left === 0" disabled class="button" id="fullt">Fullt</button></td>
      </div>

    </a>

    <!-- DROPDOWN ACTIVE -->
    <div id="workout-dropdown" :class="{ 'is-hidden': workout.keyW != activeWorkout.keyW }">

      <!-- FULL INFO DROPDOWN -->
      <div class="container" id="workout-full-info">

        <!-- CENTER DESCRIPTION -->
        <div class="columns">

          <div class="column is-two-thirds" id="workout-dropdown-image">

            <h4 class="title is-4">{{activeWorkout.name}}</h4>
            <p class="subtitle is-6" id="bit-of-padding-bottom">{{activeWorkout.description}}</p>

            <h4 class="title is-5"><i class="fas fa-map-marker-alt" id="icon-location"></i> {{activeWorkout.studio.name}}</h4>
            <p class="subtitle is-6"  id="bit-of-padding-bottom">{{activeWorkout.studio.address.number}}, {{activeWorkout.studio.address.street}}, {{activeWorkout.studio.address.city}}</p>

            <!-- FACILITIES -->
            <!--<h4 class="title is-5" id="what-you-need">Hva du trenger:</h4>-->
            <!--<p v-if="activeWorkout.facilities.shower != true">Dusj</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.mat != true}">Matte</p>-->
            <!--<p v-if="activeWorkout.facilities.changingRoom != true">Garderobe</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.towel != true}"  id="bit-of-padding-bottom">Håndkle</p>-->



            <div class="columns">
              <div class="column has-text-centered">
                <button v-if="!isAttending(workout)" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon-in-container">Book time</button>
                <button v-if="isAttending(workout)" :disabled="!currentUserId || isAttending(workout)" class="button" @click="bookModal(workout)" id="pameld-in-container">Påmeldt</button>
              </div>


            </div>


          </div>

          <div class="column is-one-third" id="workout-dropdown">

            <figure class="workout-image">
              <img src="../assets/pilates-tile-test.jpg">
            </figure>


          </div>





        </div>
      </div>
      <br><br><br>
    </div>
    <hr class="explore-divider"></hr>
  </div>

  <!-- SECOND DAY -->
  <div class="container" id="explore-container" v-for="(workout, index) in workouts_sorted_time" v-if="tomorrow(workout) && activeDay === 'Tirsdag' && ((activeType === workout.type || activeType === 'all')  && (activeStudio === workout.studio.name || activeStudio === 'all'))">
    <a @click="launchActiveWorkout(workout)"  class="columns is-centered" id="explore-column">

      <div class="column"  id="workout-time">
        <th>{{workout.time}}</th>
      </div>
      <div class="column" id="workout-duration">
        <td>{{workout.duration}} min</td>
      </div>
      <div class="column" id="workout-name">
        <h1><a @click="launchActiveWorkout(workout)" id="workout-name-a">{{workout.name}}</a></h1>
      </div>
      <div class="column" id="workout-studio">
        <h1>{{workout.studio.name}}</h1>
      </div>
      <div class="column" id="workout-type">
        <td>{{workout.type}}</td>
      </div>
      <div class="column" id="workout-places">
        <td>Ledige plasser: {{workout.places_left}}</td>
      </div>
      <div class="column" id="workout-book">
        <td id="workout-book-2"><button v-if="!isAttending(workout) && workout.places_left != 0" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon">Book time</button></td>
        <td id="workout-book-2"><button v-if="isAttending(workout)" disabled class="button" id="pameld">Påmeldt</button></td> <td id="workout-book-2"><button v-if="workout.places_left === 0" disabled class="button" id="fullt">Fullt</button></td>
      </div>

    </a>


    <!-- DROPDOWN ACTIVE -->
    <div id="workout-dropdown" :class="{ 'is-hidden': workout.keyW != activeWorkout.keyW }">

      <!-- FULL INFO DROPDOWN -->
      <div class="container" id="workout-full-info">

        <!-- CENTER DESCRIPTION -->
        <div class="columns">

          <div class="column is-two-thirds" id="workout-dropdown-image">

            <h4 class="title is-4">{{activeWorkout.name}}</h4>
            <p class="subtitle is-6" id="bit-of-padding-bottom">{{activeWorkout.description}}</p>

            <h4 class="title is-5"><i class="fas fa-map-marker-alt" id="icon-location"></i> {{activeWorkout.studio.name}}</h4>
            <p class="subtitle is-6"  id="bit-of-padding-bottom">{{activeWorkout.studio.address.street}} {{activeWorkout.studio.address.number}}, {{activeWorkout.studio.address.city}}</p>

            <!-- FACILITIES -->
            <!--<h4 class="title is-5" id="what-you-need">Hva du trenger:</h4>-->
            <!--<p v-if="activeWorkout.facilities.shower != true">Dusj</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.mat != true}">Matte</p>-->
            <!--<p v-if="activeWorkout.facilities.changingRoom != true">Garderobe</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.towel != true}"  id="bit-of-padding-bottom">Håndkle</p>-->



            <div class="columns">
              <div class="column has-text-centered">
                <button v-if="!isAttending(workout)" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon-in-container">Book time</button>
                <button v-if="isAttending(workout)" :disabled="!currentUserId || isAttending(workout)" class="button" @click="bookModal(workout)" id="pameld-in-container">Påmeldt</button>
              </div>


            </div>


          </div>

          <div class="column is-one-third" id="workout-dropdown">

            <figure class="workout-image">
              <img src="../assets/yoga-300.jpg">
            </figure>


          </div>

        </div>
      </div>
      <br><br><br>
    </div>
    <hr class="explore-divider"></hr>
  </div>

  <!-- THIRD DAY -->
  <div class="container" id="explore-container" v-for="(workout, index) in workouts_sorted_time" v-if="thirdday(workout) && activeDay === 'Onsdag' && ((activeType === workout.type || activeType === 'all')  && (activeStudio === workout.studio.name || activeStudio === 'all'))">
    <a @click="launchActiveWorkout(workout)"  class="columns is-centered" id="explore-column">

      <div class="column"  id="workout-time">
        <th>{{workout.time}}</th>
      </div>
      <div class="column" id="workout-duration">
        <td>{{workout.duration}} min</td>
      </div>
      <div class="column" id="workout-name">
        <h1><a @click="launchActiveWorkout(workout)" id="workout-name-a">{{workout.name}}</a></h1>
      </div>
      <div class="column" id="workout-studio">
        <h1>{{workout.studio.name}}</h1>
      </div>
      <div class="column" id="workout-type">
        <td>{{workout.type}}</td>
      </div>
      <div class="column" id="workout-places">
        <td>Ledige plasser: {{workout.places_left}}</td>
      </div>
      <div class="column" id="workout-book">
        <td id="workout-book-2"><button v-if="!isAttending(workout) && workout.places_left != 0" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon">Book time</button></td>
        <td id="workout-book-2"><button v-if="isAttending(workout)" disabled class="button" id="pameld">Påmeldt</button></td> <td id="workout-book-2"><button v-if="workout.places_left === 0" disabled class="button" id="fullt">Fullt</button></td>
      </div>

    </a>


    <!-- DROPDOWN ACTIVE -->
    <div id="workout-dropdown" :class="{ 'is-hidden': workout.keyW != activeWorkout.keyW }">

      <!-- FULL INFO DROPDOWN -->
      <div class="container" id="workout-full-info">

        <!-- CENTER DESCRIPTION -->
        <div class="columns">

          <div class="column is-two-thirds" id="workout-dropdown-image">

            <h4 class="title is-4">{{activeWorkout.name}}</h4>
            <p class="subtitle is-6" id="bit-of-padding-bottom">{{activeWorkout.description}}</p>

            <h4 class="title is-5"><i class="fas fa-map-marker-alt" id="icon-location"></i> {{activeWorkout.studio.name}}</h4>
            <p class="subtitle is-6"  id="bit-of-padding-bottom">{{activeWorkout.studio.address.number}}, {{activeWorkout.studio.address.street}}, {{activeWorkout.studio.address.city}}</p>

            <!-- FACILITIES -->
            <!--<h4 class="title is-5" id="what-you-need">Hva du trenger:</h4>-->
            <!--<p v-if="activeWorkout.facilities.shower != true">Dusj</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.mat != true}">Matte</p>-->
            <!--<p v-if="activeWorkout.facilities.changingRoom != true">Garderobe</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.towel != true}"  id="bit-of-padding-bottom">Håndkle</p>-->



            <div class="columns">
              <div class="column has-text-centered">
                <button v-if="!isAttending(workout)" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon-in-container">Book time</button>
                <button v-if="isAttending(workout)" :disabled="!currentUserId || isAttending(workout)" class="button" @click="bookModal(workout)" id="pameld-in-container">Påmeldt</button>
              </div>


            </div>


          </div>

          <div class="column is-one-third" id="workout-dropdown">


            <figure class="workout-image">
              <img src="../assets/yoga-300.jpg">
            </figure>


          </div>

        </div>
      </div>
      <br><br><br>
    </div>
    <hr class="explore-divider"></hr>
  </div>

  <!-- FOURTH DAY -->
  <div class="container" id="explore-container" v-for="(workout, index) in workouts_sorted_time" v-if="fourthday(workout) && activeDay === 'Torsdag' && ((activeType === workout.type || activeType === 'all')  && (activeStudio === workout.studio.name || activeStudio === 'all'))">
    <a @click="launchActiveWorkout(workout)"  class="columns is-centered" id="explore-column">

      <div class="column"  id="workout-time">
        <th>{{workout.time}}</th>
      </div>
      <div class="column" id="workout-duration">
        <td>{{workout.duration}} min</td>
      </div>
      <div class="column" id="workout-name">
        <h1><a @click="launchActiveWorkout(workout)" id="workout-name-a">{{workout.name}}</a></h1>
      </div>
      <div class="column" id="workout-studio">
        <h1>{{workout.studio.name}}</h1>
      </div>
      <div class="column" id="workout-type">
        <td>{{workout.type}}</td>
      </div>
      <div class="column" id="workout-places">
        <td>Ledige plasser: {{workout.places_left}}</td>
      </div>
      <div class="column" id="workout-book">
        <td id="workout-book-2"><button v-if="!isAttending(workout) && workout.places_left != 0" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon">Book time</button></td>
        <td id="workout-book-2"><button v-if="isAttending(workout)" disabled class="button" id="pameld">Påmeldt</button></td> <td id="workout-book-2"><button v-if="workout.places_left === 0" disabled class="button" id="fullt">Fullt</button></td>
      </div>

    </a>


    <!-- DROPDOWN ACTIVE -->
    <div id="workout-dropdown" :class="{ 'is-hidden': workout.keyW != activeWorkout.keyW }">

      <!-- FULL INFO DROPDOWN -->
      <div class="container" id="workout-full-info">

        <!-- CENTER DESCRIPTION -->
        <div class="columns">

          <div class="column is-two-thirds" id="workout-dropdown-image">

            <h4 class="title is-4">{{activeWorkout.name}}</h4>
            <p class="subtitle is-6" id="bit-of-padding-bottom">{{activeWorkout.description}}</p>

            <h4 class="title is-5"><i class="fas fa-map-marker-alt" id="icon-location"></i> {{activeWorkout.studio.name}}</h4>
            <p class="subtitle is-6"  id="bit-of-padding-bottom">{{activeWorkout.studio.address.number}}, {{activeWorkout.studio.address.street}}, {{activeWorkout.studio.address.city}}</p>

            <!-- FACILITIES -->
            <!--<h4 class="title is-5" id="what-you-need">Hva du trenger:</h4>-->
            <!--<p v-if="activeWorkout.facilities.shower != true">Dusj</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.mat != true}">Matte</p>-->
            <!--<p v-if="activeWorkout.facilities.changingRoom != true">Garderobe</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.towel != true}"  id="bit-of-padding-bottom">Håndkle</p>-->



            <div class="columns">
              <div class="column has-text-centered">
                <button v-if="!isAttending(workout)" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon-in-container">Book time</button>
                <button v-if="isAttending(workout)" :disabled="!currentUserId || isAttending(workout)" class="button" @click="bookModal(workout)" id="pameld-in-container">Påmeldt</button>
              </div>


            </div>


          </div>

          <div class="column is-one-third" id="workout-dropdown">

            <figure class="workout-image">
              <img src="../assets/yoga-300.jpg">
            </figure>


          </div>

        </div>
      </div>
      <br><br><br>
    </div>
    <hr class="explore-divider"></hr>
  </div>

  <!-- FIFTH DAY -->
  <div class="container" id="explore-container" v-for="(workout, index) in workouts_sorted_time" v-if="fifthday(workout) && activeDay === 'Fredag' && ((activeType === workout.type || activeType === 'all')  && (activeStudio === workout.studio.name || activeStudio === 'all'))">
    <a @click="launchActiveWorkout(workout)"  class="columns is-centered" id="explore-column">

      <div class="column"  id="workout-time">
        <th>{{workout.time}}</th>
      </div>
      <div class="column" id="workout-duration">
        <td>{{workout.duration}} min</td>
      </div>
      <div class="column" id="workout-name">
        <h1><a @click="launchActiveWorkout(workout)" id="workout-name-a">{{workout.name}}</a></h1>
      </div>
      <div class="column" id="workout-studio">
        <h1>{{workout.studio.name}}</h1>
      </div>
      <div class="column" id="workout-type">
        <td>{{workout.type}}</td>
      </div>
      <div class="column" id="workout-places">
        <td>Ledige plasser: {{workout.places_left}}</td>
      </div>
      <div class="column" id="workout-book">
        <td id="workout-book-2"><button v-if="!isAttending(workout) && workout.places_left != 0" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon">Book time</button></td>
        <td id="workout-book-2"><button v-if="isAttending(workout)" disabled class="button" id="pameld">Påmeldt</button></td> <td id="workout-book-2"><button v-if="workout.places_left === 0" disabled class="button" id="fullt">Fullt</button></td>
      </div>

    </a>


    <!-- DROPDOWN ACTIVE -->
    <div id="workout-dropdown" :class="{ 'is-hidden': workout.keyW != activeWorkout.keyW }">

      <!-- FULL INFO DROPDOWN -->
      <div class="container" id="workout-full-info">

        <!-- CENTER DESCRIPTION -->
        <div class="columns">

          <div class="column is-two-thirds" id="workout-dropdown-image">

            <h4 class="title is-4">{{activeWorkout.name}}</h4>
            <p class="subtitle is-6" id="bit-of-padding-bottom">{{activeWorkout.description}}</p>

            <h4 class="title is-5"><i class="fas fa-map-marker-alt" id="icon-location"></i> {{activeWorkout.studio.name}}</h4>
            <p class="subtitle is-6"  id="bit-of-padding-bottom">{{activeWorkout.studio.address.number}}, {{activeWorkout.studio.address.street}}, {{activeWorkout.studio.address.city}}</p>

            <!-- FACILITIES -->
            <!--<h4 class="title is-5" id="what-you-need">Hva du trenger:</h4>-->
            <!--<p v-if="activeWorkout.facilities.shower != true">Dusj</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.mat != true}">Matte</p>-->
            <!--<p v-if="activeWorkout.facilities.changingRoom != true">Garderobe</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.towel != true}"  id="bit-of-padding-bottom">Håndkle</p>-->



            <div class="columns">
              <div class="column has-text-centered">
                <button v-if="!isAttending(workout)" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon-in-container">Book time</button>
                <button v-if="isAttending(workout)" :disabled="!currentUserId || isAttending(workout)" class="button" @click="bookModal(workout)" id="pameld-in-container">Påmeldt</button>
              </div>


            </div>


          </div>

          <div class="column is-one-third" id="workout-dropdown">

            <figure class="workout-image">
              <img src="../assets/yoga-300.jpg">
            </figure>


          </div>

        </div>
      </div>
      <br><br><br>
    </div>
    <hr class="explore-divider"></hr>
  </div>

  <!-- SIXTH DAY -->
  <div class="container" id="explore-container" v-for="(workout, index) in workouts_sorted_time" v-if="sixthday(workout) && activeDay === 'Lørdag' && ((activeType === workout.type || activeType === 'all')  && (activeStudio === workout.studio.name || activeStudio === 'all'))">
    <a @click="launchActiveWorkout(workout)"  class="columns is-centered" id="explore-column">

      <div class="column"  id="workout-time">
        <th>{{workout.time}}</th>
      </div>
      <div class="column" id="workout-duration">
        <td>{{workout.duration}} min</td>
      </div>
      <div class="column" id="workout-name">
        <h1><a @click="launchActiveWorkout(workout)" id="workout-name-a">{{workout.name}}</a></h1>
      </div>
      <div class="column" id="workout-studio">
        <h1>{{workout.studio.name}}</h1>
      </div>
      <div class="column" id="workout-type">
        <td>{{workout.type}}</td>
      </div>
      <div class="column" id="workout-places">
        <td>Ledige plasser: {{workout.places_left}}</td>
      </div>
      <div class="column" id="workout-book">
        <td id="workout-book-2"><button v-if="!isAttending(workout) && workout.places_left != 0" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon">Book time</button></td>
        <td id="workout-book-2"><button v-if="isAttending(workout)" disabled class="button" id="pameld">Påmeldt</button></td> <td id="workout-book-2"><button v-if="workout.places_left === 0" disabled class="button" id="fullt">Fullt</button></td>
      </div>

    </a>


    <!-- DROPDOWN ACTIVE -->
    <div id="workout-dropdown" :class="{ 'is-hidden': workout.keyW != activeWorkout.keyW }">

      <!-- FULL INFO DROPDOWN -->
      <div class="container" id="workout-full-info">

        <!-- CENTER DESCRIPTION -->
        <div class="columns">

          <div class="column is-two-thirds" id="workout-dropdown-image">

            <h4 class="title is-4">{{activeWorkout.name}}</h4>
            <p class="subtitle is-6" id="bit-of-padding-bottom">{{activeWorkout.description}}</p>

            <h4 class="title is-5"><i class="fas fa-map-marker-alt" id="icon-location"></i> {{activeWorkout.studio.name}}</h4>
            <p class="subtitle is-6"  id="bit-of-padding-bottom">{{activeWorkout.studio.address.number}}, {{activeWorkout.studio.address.street}}, {{activeWorkout.studio.address.city}}</p>

            <!-- FACILITIES -->
            <!--<h4 class="title is-5" id="what-you-need">Hva du trenger:</h4>-->
            <!--<p v-if="activeWorkout.facilities.shower != true">Dusj</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.mat != true}">Matte</p>-->
            <!--<p v-if="activeWorkout.facilities.changingRoom != true">Garderobe</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.towel != true}"  id="bit-of-padding-bottom">Håndkle</p>-->



            <div class="columns">
              <div class="column has-text-centered">
                <button v-if="!isAttending(workout)" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon-in-container">Book time</button>
                <button v-if="isAttending(workout)" :disabled="!currentUserId || isAttending(workout)" class="button" @click="bookModal(workout)" id="pameld-in-container">Påmeldt</button>
              </div>


            </div>


          </div>

          <div class="column is-one-third" id="workout-dropdown">

            <figure class="workout-image">
              <img src="../assets/yoga-300.jpg">
            </figure>


          </div>

        </div>
      </div>
      <br><br><br>
    </div>
    <hr class="explore-divider"></hr>
  </div>

  <!-- SEVENTH DAY -->
  <div class="container" id="explore-container" v-for="(workout, index) in workouts_sorted_time" v-if="seventhday(workout) && activeDay === 'Søndag' && ((activeType === workout.type || activeType === 'all')  && (activeStudio === workout.studio.name || activeStudio === 'all'))">
    <a @click="launchActiveWorkout(workout)"  class="columns is-centered" id="explore-column">

      <div class="column"  id="workout-time">
        <th>{{workout.time}}</th>
      </div>
      <div class="column" id="workout-duration">
        <td>{{workout.duration}} min</td>
      </div>
      <div class="column" id="workout-name">
        <h1><a @click="launchActiveWorkout(workout)" id="workout-name-a">{{workout.name}}</a></h1>
      </div>
      <div class="column" id="workout-studio">
        <h1>{{workout.studio.name}}</h1>
      </div>
      <div class="column" id="workout-type">
        <td>{{workout.type}}</td>
      </div>
      <div class="column" id="workout-places">
        <td>Ledige plasser: {{workout.places_left}}</td>
      </div>
      <div class="column" id="workout-book">
        <td id="workout-book-2"><button v-if="!isAttending(workout) && workout.places_left != 0" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon">Book time</button></td>
        <td id="workout-book-2"><button v-if="isAttending(workout)" disabled class="button" id="pameld">Påmeldt</button></td> <td id="workout-book-2"><button v-if="workout.places_left === 0" disabled class="button" id="fullt">Fullt</button></td>
      </div>

    </a>


    <!-- DROPDOWN ACTIVE -->
    <div id="workout-dropdown" :class="{ 'is-hidden': workout.keyW != activeWorkout.keyW }">

      <!-- FULL INFO DROPDOWN -->
      <div class="container" id="workout-full-info">

        <!-- CENTER DESCRIPTION -->
        <div class="columns">

          <div class="column is-two-thirds" id="workout-dropdown-image">

            <h4 class="title is-4">{{activeWorkout.name}}</h4>
            <p class="subtitle is-6" id="bit-of-padding-bottom">{{activeWorkout.description}}</p>

            <h4 class="title is-5"><i class="fas fa-map-marker-alt" id="icon-location"></i> {{activeWorkout.studio.name}}</h4>
            <p class="subtitle is-6"  id="bit-of-padding-bottom">{{activeWorkout.studio.address.number}}, {{activeWorkout.studio.address.street}}, {{activeWorkout.studio.address.city}}</p>

            <!-- FACILITIES -->
            <!--<h4 class="title is-5" id="what-you-need">Hva du trenger:</h4>-->
            <!--<p v-if="activeWorkout.facilities.shower != true">Dusj</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.mat != true}">Matte</p>-->
            <!--<p v-if="activeWorkout.facilities.changingRoom != true">Garderobe</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.towel != true}"  id="bit-of-padding-bottom">Håndkle</p>-->



            <div class="columns">
              <div class="column has-text-centered">
                <button v-if="!isAttending(workout)" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon-in-container">Book time</button>
                <button v-if="isAttending(workout)" :disabled="!currentUserId || isAttending(workout)" class="button" @click="bookModal(workout)" id="pameld-in-container">Påmeldt</button>
              </div>


            </div>


          </div>

          <div class="column is-one-third" id="workout-dropdown">

            <figure class="workout-image">
              <img src="../assets/yoga-300.jpg">
            </figure>


          </div>

        </div>
      </div>
      <br><br><br>
    </div>
    <hr class="explore-divider"></hr>
  </div>
<!-- SECOND WEEK -->
  <!-- SW_FIRST DAY -->
  <div class="container" id="explore-container" v-for="(workout, index) in workouts_sorted_time" v-if="(sw_today(workout) && activeDay === 'sw_Mandag') && ((activeType === workout.type || activeType === 'all')  && (activeStudio === workout.studio.name || activeStudio === 'all'))">
    <a @click="launchActiveWorkout(workout)"  class="columns is-centered" id="explore-column">

      <div class="column"  id="workout-time">
        <th>{{workout.time}}</th>
      </div>
      <div class="column" id="workout-duration">
        <td>{{workout.duration}} min</td>
      </div>
      <div class="column" id="workout-name">
        <h1><a @click="launchActiveWorkout(workout)" id="workout-name-a">{{workout.name}}</a></h1>
      </div>
      <div class="column" id="workout-studio">
        <h1>{{workout.studio.name}}</h1>
      </div>
      <div class="column" id="workout-type">
        <td>{{workout.type}}</td>
      </div>
      <div class="column" id="workout-places">
        <td>Ledige plasser: {{workout.places_left}}</td>
      </div>
      <div class="column" id="workout-book">
        <td id="workout-book-2"><button v-if="!isAttending(workout) && workout.places_left != 0" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon">Book time</button></td>
        <td id="workout-book-2"><button v-if="isAttending(workout)" disabled class="button" id="pameld">Påmeldt</button></td> <td id="workout-book-2"><button v-if="workout.places_left === 0" disabled class="button" id="fullt">Fullt</button></td>
      </div>

    </a>


    <!-- DROPDOWN ACTIVE -->
    <div id="workout-dropdown" :class="{ 'is-hidden': workout.keyW != activeWorkout.keyW }">

      <!-- FULL INFO DROPDOWN -->
      <div class="container" id="workout-full-info">

        <!-- CENTER DESCRIPTION -->
        <div class="columns">

          <div class="column is-two-thirds" id="workout-dropdown-image">

            <h4 class="title is-4">{{activeWorkout.name}}</h4>
            <p class="subtitle is-6" id="bit-of-padding-bottom">{{activeWorkout.description}}</p>

            <h4 class="title is-5"><i class="fas fa-map-marker-alt" id="icon-location"></i> {{activeWorkout.studio.name}}</h4>
            <p class="subtitle is-6"  id="bit-of-padding-bottom">{{activeWorkout.studio.address.number}}, {{activeWorkout.studio.address.street}}, {{activeWorkout.studio.address.city}}</p>

            <!-- FACILITIES -->
            <!--<h4 class="title is-5" id="what-you-need">Hva du trenger:</h4>-->
            <!--<p v-if="activeWorkout.facilities.shower != true">Dusj</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.mat != true}">Matte</p>-->
            <!--<p v-if="activeWorkout.facilities.changingRoom != true">Garderobe</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.towel != true}"  id="bit-of-padding-bottom">Håndkle</p>-->



            <div class="columns">
              <div class="column has-text-centered">
                <button v-if="!isAttending(workout)" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon-in-container">Book time</button>
                <button v-if="isAttending(workout)" :disabled="!currentUserId || isAttending(workout)" class="button" @click="bookModal(workout)" id="pameld-in-container">Påmeldt</button>
              </div>


            </div>


          </div>

          <div class="column is-one-third" id="workout-dropdown">

            <figure class="workout-image">
              <img src="../assets/yoga-300.jpg">
            </figure>


          </div>

        </div>
      </div>
      <br><br><br>
    </div>
    <hr class="explore-divider"></hr>
  </div>

  <!-- SW_SECOND DAY -->
  <div class="container" id="explore-container" v-for="(workout, index) in workouts_sorted_time" v-if="sw_tomorrow(workout) && activeDay === 'sw_Tirsdag' && ((activeType === workout.type || activeType === 'all')  && (activeStudio === workout.studio.name || activeStudio === 'all'))">
    <a @click="launchActiveWorkout(workout)"  class="columns is-centered" id="explore-column">

      <div class="column"  id="workout-time">
        <th>{{workout.time}}</th>
      </div>
      <div class="column" id="workout-duration">
        <td>{{workout.duration}} min</td>
      </div>
      <div class="column" id="workout-name">
        <h1><a @click="launchActiveWorkout(workout)" id="workout-name-a">{{workout.name}}</a></h1>
      </div>
      <div class="column" id="workout-studio">
        <h1>{{workout.studio.name}}</h1>
      </div>
      <div class="column" id="workout-type">
        <td>{{workout.type}}</td>
      </div>
      <div class="column" id="workout-places">
        <td>Ledige plasser: {{workout.places_left}}</td>
      </div>
      <div class="column" id="workout-book">
        <td id="workout-book-2"><button :disabled="!currentUserId" class="button" href="/sign-up" id="meldon">Book time</button></td>
        <td id="workout-book-2"><button v-if="isAttending(workout)" disabled class="button" id="pameld">Påmeldt</button></td> <td id="workout-book-2"><button v-if="workout.places_left === 0" disabled class="button" id="fullt">Fullt</button></td>
      </div>

    </a>


    <!-- DROPDOWN ACTIVE -->
    <div id="workout-dropdown" :class="{ 'is-hidden': workout.keyW != activeWorkout.keyW }">

      <!-- FULL INFO DROPDOWN -->
      <div class="container" id="workout-full-info">

        <!-- CENTER DESCRIPTION -->
        <div class="columns">

          <div class="column is-two-thirds" id="workout-dropdown-image">

            <h4 class="title is-4" id="dropdown-font">{{activeWorkout.name}}</h4>
            <p class="subtitle is-6" id="bit-of-padding-bottom">{{activeWorkout.description}}</p>

            <h4 class="title is-5"><i class="fas fa-map-marker-alt" id="icon-location"></i> {{activeWorkout.studio.name}}</h4>
            <p class="subtitle is-6"  id="bit-of-padding-bottom">{{activeWorkout.studio.address.street}} {{activeWorkout.studio.address.number}}, {{activeWorkout.studio.address.city}}</p>

            <!-- FACILITIES -->
            <!--<h4 class="title is-5" id="what-you-need">Hva du trenger:</h4>-->
            <!--<p v-if="activeWorkout.facilities.shower != true">Dusj</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.mat != true}">Matte</p>-->
            <!--<p v-if="activeWorkout.facilities.changingRoom != true">Garderobe</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.towel != true}"  id="bit-of-padding-bottom">Håndkle</p>-->



            <div class="columns">
              <div class="column has-text-centered">
                <button v-if="!isAttending(workout)" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon-in-container">Book time</button>
                <button v-if="isAttending(workout)" :disabled="!currentUserId || isAttending(workout)" class="button" @click="bookModal(workout)" id="pameld-in-container">Påmeldt</button>
              </div>


            </div>


          </div>

          <div class="column is-one-third" id="workout-dropdown">

            <figure class="workout-image">
              <img src="../assets/yoga-300.jpg">
            </figure>


          </div>

        </div>
      </div>
      <br><br><br>
    </div>
    <hr class="explore-divider"></hr>
  </div>

  <!-- SW_THIRD DAY -->
  <div class="container" id="explore-container" v-for="(workout, index) in workouts_sorted_time" v-if="sw_thirdday(workout) && activeDay === 'sw_Onsdag' && ((activeType === workout.type || activeType === 'all')  && (activeStudio === workout.studio.name || activeStudio === 'all'))">
    <a @click="launchActiveWorkout(workout)"  class="columns is-centered" id="explore-column">

      <div class="column"  id="workout-time">
        <th>{{workout.time}}</th>
      </div>
      <div class="column" id="workout-duration">
        <td>{{workout.duration}} min</td>
      </div>
      <div class="column" id="workout-name">
        <h1><a @click="launchActiveWorkout(workout)" id="workout-name-a">{{workout.name}}</a></h1>
      </div>
      <div class="column" id="workout-studio">
        <h1>{{workout.studio.name}}</h1>
      </div>
      <div class="column" id="workout-type">
        <td>{{workout.type}}</td>
      </div>
      <div class="column" id="workout-places">
        <td>Ledige plasser: {{workout.places_left}}</td>
      </div>
      <div class="column" id="workout-book">
        <td id="workout-book-2"><button v-if="!isAttending(workout) && workout.places_left != 0" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon">Book time</button></td>
        <td id="workout-book-2"><button v-if="isAttending(workout)" disabled class="button" id="pameld">Påmeldt</button></td> <td id="workout-book-2"><button v-if="workout.places_left === 0" disabled class="button" id="fullt">Fullt</button></td>
      </div>

    </a>


    <!-- DROPDOWN ACTIVE -->
    <div id="workout-dropdown" :class="{ 'is-hidden': workout.keyW != activeWorkout.keyW }">

      <!-- FULL INFO DROPDOWN -->
      <div class="container" id="workout-full-info">

        <!-- CENTER DESCRIPTION -->
        <div class="columns">

          <div class="column is-two-thirds" id="workout-dropdown-image">

            <h4 class="title is-4">{{activeWorkout.name}}</h4>
            <p class="subtitle is-6" id="bit-of-padding-bottom">{{activeWorkout.description}}</p>

            <h4 class="title is-5"><i class="fas fa-map-marker-alt" id="icon-location"></i> {{activeWorkout.studio.name}}</h4>
            <p class="subtitle is-6"  id="bit-of-padding-bottom">{{activeWorkout.studio.address.number}}, {{activeWorkout.studio.address.street}}, {{activeWorkout.studio.address.city}}</p>

            <!-- FACILITIES -->
            <!--<h4 class="title is-5" id="what-you-need">Hva du trenger:</h4>-->
            <!--<p v-if="activeWorkout.facilities.shower != true">Dusj</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.mat != true}">Matte</p>-->
            <!--<p v-if="activeWorkout.facilities.changingRoom != true">Garderobe</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.towel != true}"  id="bit-of-padding-bottom">Håndkle</p>-->



            <div class="columns">
              <div class="column has-text-centered">
                <button v-if="!isAttending(workout)" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon-in-container">Book time</button>
                <button v-if="isAttending(workout)" :disabled="!currentUserId || isAttending(workout)" class="button" @click="bookModal(workout)" id="pameld-in-container">Påmeldt</button>
              </div>


            </div>


          </div>

          <div class="column is-one-third" id="workout-dropdown">

            <figure class="workout-image">
              <img src="../assets/yoga-300.jpg">
            </figure>


          </div>

        </div>
      </div>
      <br><br><br>
    </div>
    <hr class="explore-divider"></hr>
  </div>

  <!-- SW_FOURTH DAY -->
  <div class="container" id="explore-container" v-for="(workout, index) in workouts_sorted_time" v-if="sw_fourthday(workout) && activeDay === 'sw_Torsdag' && ((activeType === workout.type || activeType === 'all')  && (activeStudio === workout.studio.name || activeStudio === 'all'))">
    <a @click="launchActiveWorkout(workout)"  class="columns is-centered" id="explore-column">

      <div class="column"  id="workout-time">
        <th>{{workout.time}}</th>
      </div>
      <div class="column" id="workout-duration">
        <td>{{workout.duration}} min</td>
      </div>
      <div class="column" id="workout-name">
        <h1><a @click="launchActiveWorkout(workout)" id="workout-name-a">{{workout.name}}</a></h1>
      </div>
      <div class="column" id="workout-studio">
        <h1>{{workout.studio.name}}</h1>
      </div>
      <div class="column" id="workout-type">
        <td>{{workout.type}}</td>
      </div>
      <div class="column" id="workout-places">
        <td>Ledige plasser: {{workout.places_left}}</td>
      </div>
      <div class="column" id="workout-book">
        <td id="workout-book-2"><button v-if="!isAttending(workout) && workout.places_left != 0" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon">Book time</button></td>
        <td id="workout-book-2"><button v-if="isAttending(workout)" disabled class="button" id="pameld">Påmeldt</button></td> <td id="workout-book-2"><button v-if="workout.places_left === 0" disabled class="button" id="fullt">Fullt</button></td>
      </div>

    </a>


    <!-- DROPDOWN ACTIVE -->
    <div id="workout-dropdown" :class="{ 'is-hidden': workout.keyW != activeWorkout.keyW }">

      <!-- FULL INFO DROPDOWN -->
      <div class="container" id="workout-full-info">

        <!-- CENTER DESCRIPTION -->
        <div class="columns">

          <div class="column is-two-thirds" id="workout-dropdown-image">

            <h4 class="title is-4">{{activeWorkout.name}}</h4>
            <p class="subtitle is-6" id="bit-of-padding-bottom">{{activeWorkout.description}}</p>

            <h4 class="title is-5"><i class="fas fa-map-marker-alt" id="icon-location"></i> {{activeWorkout.studio.name}}</h4>
            <p class="subtitle is-6"  id="bit-of-padding-bottom">{{activeWorkout.studio.address.number}}, {{activeWorkout.studio.address.street}}, {{activeWorkout.studio.address.city}}</p>

            <!-- FACILITIES -->
            <!--<h4 class="title is-5" id="what-you-need">Hva du trenger:</h4>-->
            <!--<p v-if="activeWorkout.facilities.shower != true">Dusj</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.mat != true}">Matte</p>-->
            <!--<p v-if="activeWorkout.facilities.changingRoom != true">Garderobe</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.towel != true}"  id="bit-of-padding-bottom">Håndkle</p>-->



            <div class="columns">
              <div class="column has-text-centered">
                <button v-if="!isAttending(workout)" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon-in-container">Book time</button>
                <button v-if="isAttending(workout)" :disabled="!currentUserId || isAttending(workout)" class="button" @click="bookModal(workout)" id="pameld-in-container">Påmeldt</button>
              </div>


            </div>


          </div>

          <div class="column is-one-third" id="workout-dropdown">

            <figure class="workout-image">
              <img src="../assets/yoga-300.jpg">
            </figure>


          </div>

        </div>
      </div>
      <br><br><br>
    </div>
    <hr class="explore-divider"></hr>
  </div>

  <!-- SW_FIFTH DAY -->
  <div class="container" id="explore-container" v-for="(workout, index) in workouts_sorted_time" v-if="sw_fifthday(workout) && activeDay === 'sw_Fredag' && ((activeType === workout.type || activeType === 'all')  && (activeStudio === workout.studio.name || activeStudio === 'all'))">
    <a @click="launchActiveWorkout(workout)"  class="columns is-centered" id="explore-column">

      <div class="column"  id="workout-time">
        <th>{{workout.time}}</th>
      </div>
      <div class="column" id="workout-duration">
        <td>{{workout.duration}} min</td>
      </div>
      <div class="column" id="workout-name">
        <h1><a @click="launchActiveWorkout(workout)" id="workout-name-a">{{workout.name}}</a></h1>
      </div>
      <div class="column" id="workout-studio">
        <h1>{{workout.studio.name}}</h1>
      </div>
      <div class="column" id="workout-type">
        <td>{{workout.type}}</td>
      </div>
      <div class="column" id="workout-places">
        <td>Ledige plasser: {{workout.places_left}}</td>
      </div>
      <div class="column" id="workout-book">
        <td id="workout-book-2"><button v-if="!isAttending(workout) && workout.places_left != 0" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon">Book time</button></td>
        <td id="workout-book-2"><button v-if="isAttending(workout)" disabled class="button" id="pameld">Påmeldt</button></td> <td id="workout-book-2"><button v-if="workout.places_left === 0" disabled class="button" id="fullt">Fullt</button></td>
      </div>

    </a>


    <!-- DROPDOWN ACTIVE -->
    <div id="workout-dropdown" :class="{ 'is-hidden': workout.keyW != activeWorkout.keyW }">

      <!-- FULL INFO DROPDOWN -->
      <div class="container" id="workout-full-info">

        <!-- CENTER DESCRIPTION -->
        <div class="columns">

          <div class="column is-two-thirds" id="workout-dropdown-image">

            <h4 class="title is-4">{{activeWorkout.name}}</h4>
            <p class="subtitle is-6" id="bit-of-padding-bottom">{{activeWorkout.description}}</p>

            <h4 class="title is-5"><i class="fas fa-map-marker-alt" id="icon-location"></i> {{activeWorkout.studio.name}}</h4>
            <p class="subtitle is-6"  id="bit-of-padding-bottom">{{activeWorkout.studio.address.number}}, {{activeWorkout.studio.address.street}}, {{activeWorkout.studio.address.city}}</p>

            <!-- FACILITIES -->
            <!--<h4 class="title is-5" id="what-you-need">Hva du trenger:</h4>-->
            <!--<p v-if="activeWorkout.facilities.shower != true">Dusj</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.mat != true}">Matte</p>-->
            <!--<p v-if="activeWorkout.facilities.changingRoom != true">Garderobe</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.towel != true}"  id="bit-of-padding-bottom">Håndkle</p>-->



            <div class="columns">
              <div class="column has-text-centered">
                <button v-if="!isAttending(workout)" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon-in-container">Book time</button>
                <button v-if="isAttending(workout)" :disabled="!currentUserId || isAttending(workout)" class="button" @click="bookModal(workout)" id="pameld-in-container">Påmeldt</button>
              </div>


            </div>


          </div>

          <div class="column is-one-third" id="workout-dropdown">

            <figure class="workout-image">
              <img src="../assets/yoga-300.jpg">
            </figure>


          </div>

        </div>
      </div>
      <br><br><br>
    </div>
    <hr class="explore-divider"></hr>
  </div>

  <!-- SW_SIXTH DAY -->
  <div class="container" id="explore-container" v-for="(workout, index) in workouts_sorted_time" v-if="sw_sixthday(workout) && activeDay === 'sw_Lørdag' && ((activeType === workout.type || activeType === 'all')  && (activeStudio === workout.studio.name || activeStudio === 'all'))">
    <a @click="launchActiveWorkout(workout)"  class="columns is-centered" id="explore-column">

      <div class="column"  id="workout-time">
        <th>{{workout.time}}</th>
      </div>
      <div class="column" id="workout-duration">
        <td>{{workout.duration}} min</td>
      </div>
      <div class="column" id="workout-name">
        <h1><a @click="launchActiveWorkout(workout)" id="workout-name-a">{{workout.name}}</a></h1>
      </div>
      <div class="column" id="workout-studio">
        <h1>{{workout.studio.name}}</h1>
      </div>
      <div class="column" id="workout-type">
        <td>{{workout.type}}</td>
      </div>
      <div class="column" id="workout-places">
        <td>Ledige plasser: {{workout.places_left}}</td>
      </div>
      <div class="column" id="workout-book">
        <td id="workout-book-2"><button v-if="!isAttending(workout) && workout.places_left != 0" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon">Book time</button></td>
        <td id="workout-book-2"><button v-if="isAttending(workout)" disabled class="button" id="pameld">Påmeldt</button></td> <td id="workout-book-2"><button v-if="workout.places_left === 0" disabled class="button" id="fullt">Fullt</button></td>
      </div>

    </a>


    <!-- DROPDOWN ACTIVE -->
    <div id="workout-dropdown" :class="{ 'is-hidden': workout.keyW != activeWorkout.keyW }">

      <!-- FULL INFO DROPDOWN -->
      <div class="container" id="workout-full-info">

        <!-- CENTER DESCRIPTION -->
        <div class="columns">

          <div class="column is-two-thirds" id="workout-dropdown-image">

            <h4 class="title is-4">{{activeWorkout.name}}</h4>
            <p class="subtitle is-6" id="bit-of-padding-bottom">{{activeWorkout.description}}</p>

            <h4 class="title is-5"><i class="fas fa-map-marker-alt" id="icon-location"></i> {{activeWorkout.studio.name}}</h4>
            <p class="subtitle is-6"  id="bit-of-padding-bottom">{{activeWorkout.studio.address.number}}, {{activeWorkout.studio.address.street}}, {{activeWorkout.studio.address.city}}</p>

            <!-- FACILITIES -->
            <!--<h4 class="title is-5" id="what-you-need">Hva du trenger:</h4>-->
            <!--<p v-if="activeWorkout.facilities.shower != true">Dusj</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.mat != true}">Matte</p>-->
            <!--<p v-if="activeWorkout.facilities.changingRoom != true">Garderobe</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.towel != true}"  id="bit-of-padding-bottom">Håndkle</p>-->



            <div class="columns">
              <div class="column has-text-centered">
                <button v-if="!isAttending(workout)" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon-in-container">Book time</button>
                <button v-if="isAttending(workout)" :disabled="!currentUserId || isAttending(workout)" class="button" @click="bookModal(workout)" id="pameld-in-container">Påmeldt</button>
              </div>


            </div>


          </div>

          <div class="column is-one-third" id="workout-dropdown">

            <figure class="workout-image">
              <img src="../assets/yoga-300.jpg">
            </figure>


          </div>

        </div>
      </div>
      <br><br><br>
    </div>
    <hr class="explore-divider"></hr>
  </div>

  <!-- SW_SEVENTH DAY -->
  <div class="container" id="explore-container" v-for="(workout, index) in workouts_sorted_time" v-if="sw_seventhday(workout) && activeDay === 'sw_Søndag' && ((activeType === workout.type || activeType === 'all')  && (activeStudio === workout.studio.name || activeStudio === 'all'))">
    <a @click="launchActiveWorkout(workout)"  class="columns is-centered" id="explore-column">

      <div class="column"  id="workout-time">
        <th>{{workout.time}}</th>
      </div>
      <div class="column" id="workout-duration">
        <td>{{workout.duration}} min</td>
      </div>
      <div class="column" id="workout-name">
        <h1><a @click="launchActiveWorkout(workout)" id="workout-name-a">{{workout.name}}</a></h1>
      </div>
      <div class="column" id="workout-studio">
        <h1>{{workout.studio.name}}</h1>
      </div>
      <div class="column" id="workout-type">
        <td>{{workout.type}}</td>
      </div>
      <div class="column" id="workout-places">
        <td>Ledige plasser: {{workout.places_left}}</td>
      </div>
      <div class="column" id="workout-book">
        <td id="workout-book-2"><button v-if="!isAttending(workout) && workout.places_left != 0" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon">Book time</button></td>
        <td id="workout-book-2"><button v-if="isAttending(workout)" disabled class="button" id="pameld">Påmeldt</button></td> <td id="workout-book-2"><button v-if="workout.places_left === 0" disabled class="button" id="fullt">Fullt</button></td>
      </div>

    </a>


    <!-- DROPDOWN ACTIVE -->
    <div id="workout-dropdown" :class="{ 'is-hidden': workout.keyW != activeWorkout.keyW }">

      <!-- FULL INFO DROPDOWN -->
      <div class="container" id="workout-full-info">

        <!-- CENTER DESCRIPTION -->
        <div class="columns">

          <div class="column is-two-thirds" id="workout-dropdown-image">

            <h4 class="title is-4">{{activeWorkout.name}}</h4>
            <p class="subtitle is-6" id="bit-of-padding-bottom">{{activeWorkout.description}}</p>

            <h4 class="title is-5"><i class="fas fa-map-marker-alt" id="icon-location"></i> {{activeWorkout.studio.name}}</h4>
            <p class="subtitle is-6"  id="bit-of-padding-bottom">{{activeWorkout.studio.address.number}}, {{activeWorkout.studio.address.street}}, {{activeWorkout.studio.address.city}}</p>

            <!-- FACILITIES -->
            <!--<h4 class="title is-5" id="what-you-need">Hva du trenger:</h4>-->
            <!--<p v-if="activeWorkout.facilities.shower != true">Dusj</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.mat != true}">Matte</p>-->
            <!--<p v-if="activeWorkout.facilities.changingRoom != true">Garderobe</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.towel != true}"  id="bit-of-padding-bottom">Håndkle</p>-->



            <div class="columns">
              <div class="column has-text-centered">
                <button v-if="!isAttending(workout)" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon-in-container">Book time</button>
                <button v-if="isAttending(workout)" :disabled="!currentUserId || isAttending(workout)" class="button" @click="bookModal(workout)" id="pameld-in-container">Påmeldt</button>
              </div>


            </div>


          </div>

          <div class="column is-one-third" id="workout-dropdown">

            <figure class="workout-image">
              <img src="../assets/yoga-300.jpg">
            </figure>


          </div>

        </div>
      </div>
      <br><br><br>
    </div>
    <hr class="explore-divider"></hr>
  </div>
<!--THIRD WEEK -->
  <!-- TW_FIRST DAY -->
  <div class="container" id="explore-container" v-for="(workout, index) in workouts_sorted_time" v-if="(tw_today(workout) && activeDay === 'tw_Mandag') && ((activeType === workout.type || activeType === 'all')  && (activeStudio === workout.studio.name || activeStudio === 'all'))">
    <a @click="launchActiveWorkout(workout)"  class="columns is-centered" id="explore-column">

      <div class="column"  id="workout-time">
        <th>{{workout.time}}</th>
      </div>
      <div class="column" id="workout-duration">
        <td>{{workout.duration}} min</td>
      </div>
      <div class="column" id="workout-name">
        <h1><a @click="launchActiveWorkout(workout)" id="workout-name-a">{{workout.name}}</a></h1>
      </div>
      <div class="column" id="workout-studio">
        <h1>{{workout.studio.name}}</h1>
      </div>
      <div class="column" id="workout-type">
        <td>{{workout.type}}</td>
      </div>
      <div class="column" id="workout-places">
        <td>Ledige plasser: {{workout.places_left}}</td>
      </div>
      <div class="column" id="workout-book">
        <td id="workout-book-2"><button v-if="!isAttending(workout) && workout.places_left != 0" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon">Book time</button></td>
        <td id="workout-book-2"><button v-if="isAttending(workout)" disabled class="button" id="pameld">Påmeldt</button></td> <td id="workout-book-2"><button v-if="workout.places_left === 0" disabled class="button" id="fullt">Fullt</button></td>
      </div>

    </a>


    <!-- DROPDOWN ACTIVE -->
    <div id="workout-dropdown" :class="{ 'is-hidden': workout.keyW != activeWorkout.keyW }">

      <!-- FULL INFO DROPDOWN -->
      <div class="container" id="workout-full-info">

        <!-- CENTER DESCRIPTION -->
        <div class="columns">

          <div class="column is-two-thirds" id="workout-dropdown-image">

            <h4 class="title is-4">{{activeWorkout.name}}</h4>
            <p class="subtitle is-6" id="bit-of-padding-bottom">{{activeWorkout.description}}</p>

            <h4 class="title is-5"><i class="fas fa-map-marker-alt" id="icon-location"></i> {{activeWorkout.studio.name}}</h4>
            <p class="subtitle is-6"  id="bit-of-padding-bottom">{{activeWorkout.studio.address.number}}, {{activeWorkout.studio.address.street}}, {{activeWorkout.studio.address.city}}</p>

            <!-- FACILITIES -->
            <!--<h4 class="title is-5" id="what-you-need">Hva du trenger:</h4>-->
            <!--<p v-if="activeWorkout.facilities.shower != true">Dusj</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.mat != true}">Matte</p>-->
            <!--<p v-if="activeWorkout.facilities.changingRoom != true">Garderobe</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.towel != true}"  id="bit-of-padding-bottom">Håndkle</p>-->



            <div class="columns">
              <div class="column has-text-centered">
                <button v-if="!isAttending(workout)" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon-in-container">Book time</button>
                <button v-if="isAttending(workout)" :disabled="!currentUserId || isAttending(workout)" class="button" @click="bookModal(workout)" id="pameld-in-container">Påmeldt</button>
              </div>


            </div>


          </div>

          <div class="column is-one-third" id="workout-dropdown">

            <figure class="workout-image">
              <img src="../assets/pilates-tile-test.jpg">
            </figure>


          </div>

        </div>
      </div>
      <br><br><br>
    </div>
    <hr class="explore-divider"></hr>
  </div>

  <!-- TW_SECOND DAY -->
  <div class="container" id="explore-container" v-for="(workout, index) in workouts_sorted_time" v-if="tw_tomorrow(workout) && activeDay === 'tw_Tirsdag' && ((activeType === workout.type || activeType === 'all')  && (activeStudio === workout.studio.name || activeStudio === 'all'))">
    <a @click="launchActiveWorkout(workout)"  class="columns is-centered" id="explore-column">

      <div class="column"  id="workout-time">
        <th>{{workout.time}}</th>
      </div>
      <div class="column" id="workout-duration">
        <td>{{workout.duration}} min</td>
      </div>
      <div class="column" id="workout-name">
        <h1><a @click="launchActiveWorkout(workout)" id="workout-name-a">{{workout.name}}</a></h1>
      </div>
      <div class="column" id="workout-studio">
        <h1>{{workout.studio.name}}</h1>
      </div>
      <div class="column" id="workout-type">
        <td>{{workout.type}}</td>
      </div>
      <div class="column" id="workout-places">
        <td>Ledige plasser: {{workout.places_left}}</td>
      </div>
      <div class="column" id="workout-book">
        <td id="workout-book-2"><button v-if="!isAttending(workout) && workout.places_left != 0" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon">Book time</button></td>
        <td id="workout-book-2"><button v-if="isAttending(workout)" disabled class="button" id="pameld">Påmeldt</button></td> <td id="workout-book-2"><button v-if="workout.places_left === 0" disabled class="button" id="fullt">Fullt</button></td>
      </div>

    </a>


    <!-- DROPDOWN ACTIVE -->
    <div id="workout-dropdown" :class="{ 'is-hidden': workout.keyW != activeWorkout.keyW }">

      <!-- FULL INFO DROPDOWN -->
      <div class="container" id="workout-full-info">

        <!-- CENTER DESCRIPTION -->
        <div class="columns">

          <div class="column is-two-thirds" id="workout-dropdown-image">

            <h4 class="title is-4">{{activeWorkout.name}}</h4>
            <p class="subtitle is-6" id="bit-of-padding-bottom">{{activeWorkout.description}}</p>

            <h4 class="title is-5"><i class="fas fa-map-marker-alt" id="icon-location"></i> {{activeWorkout.studio.name}}</h4>
            <p class="subtitle is-6"  id="bit-of-padding-bottom">{{activeWorkout.studio.address.number}}, {{activeWorkout.studio.address.street}}, {{activeWorkout.studio.address.city}}</p>

            <!-- FACILITIES -->
            <!--<h4 class="title is-5" id="what-you-need">Hva du trenger:</h4>-->
            <!--<p v-if="activeWorkout.facilities.shower != true">Dusj</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.mat != true}">Matte</p>-->
            <!--<p v-if="activeWorkout.facilities.changingRoom != true">Garderobe</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.towel != true}"  id="bit-of-padding-bottom">Håndkle</p>-->



            <div class="columns">
              <div class="column has-text-centered">
                <button v-if="!isAttending(workout)" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon-in-container">Book time</button>
                <button v-if="isAttending(workout)" :disabled="!currentUserId || isAttending(workout)" class="button" @click="bookModal(workout)" id="pameld-in-container">Påmeldt</button>
              </div>


            </div>


          </div>

          <div class="column is-one-third" id="workout-dropdown">

            <figure class="workout-image">
              <img src="../assets/yoga-300.jpg">
            </figure>


          </div>

        </div>
      </div>
      <br><br><br>
    </div>
    <hr class="explore-divider"></hr>
  </div>

  <!-- TW_THIRD DAY -->
  <div class="container" id="explore-container" v-for="(workout, index) in workouts_sorted_time" v-if="tw_thirdday(workout) && activeDay === 'tw_Onsdag' && ((activeType === workout.type || activeType === 'all')  && (activeStudio === workout.studio.name || activeStudio === 'all'))">
    <a @click="launchActiveWorkout(workout)"  class="columns is-centered" id="explore-column">

      <div class="column"  id="workout-time">
        <th>{{workout.time}}</th>
      </div>
      <div class="column" id="workout-duration">
        <td>{{workout.duration}} min</td>
      </div>
      <div class="column" id="workout-name">
        <h1><a @click="launchActiveWorkout(workout)" id="workout-name-a">{{workout.name}}</a></h1>
      </div>
      <div class="column" id="workout-studio">
        <h1>{{workout.studio.name}}</h1>
      </div>
      <div class="column" id="workout-type">
        <td>{{workout.type}}</td>
      </div>
      <div class="column" id="workout-places">
        <td>Ledige plasser: {{workout.places_left}}</td>
      </div>
      <div class="column" id="workout-book">
        <td id="workout-book-2"><button v-if="!isAttending(workout) && workout.places_left != 0" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon">Book time</button></td>
        <td id="workout-book-2"><button v-if="isAttending(workout)" disabled class="button" id="pameld">Påmeldt</button></td> <td id="workout-book-2"><button v-if="workout.places_left === 0" disabled class="button" id="fullt">Fullt</button></td>
      </div>

    </a>


    <!-- DROPDOWN ACTIVE -->
    <div id="workout-dropdown" :class="{ 'is-hidden': workout.keyW != activeWorkout.keyW }">

      <!-- FULL INFO DROPDOWN -->
      <div class="container" id="workout-full-info">

        <!-- CENTER DESCRIPTION -->
        <div class="columns">

          <div class="column is-two-thirds" id="workout-dropdown-image">

            <h4 class="title is-4">{{activeWorkout.name}}</h4>
            <p class="subtitle is-6" id="bit-of-padding-bottom">{{activeWorkout.description}}</p>

            <h4 class="title is-5"><i class="fas fa-map-marker-alt" id="icon-location"></i> {{activeWorkout.studio.name}}</h4>
            <p class="subtitle is-6"  id="bit-of-padding-bottom">{{activeWorkout.studio.address.number}}, {{activeWorkout.studio.address.street}}, {{activeWorkout.studio.address.city}}</p>

            <!-- FACILITIES -->
            <!--<h4 class="title is-5" id="what-you-need">Hva du trenger:</h4>-->
            <!--<p v-if="activeWorkout.facilities.shower != true">Dusj</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.mat != true}">Matte</p>-->
            <!--<p v-if="activeWorkout.facilities.changingRoom != true">Garderobe</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.towel != true}"  id="bit-of-padding-bottom">Håndkle</p>-->



            <div class="columns">
              <div class="column has-text-centered">
                <button v-if="!isAttending(workout)" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon-in-container">Book time</button>
                <button v-if="isAttending(workout)" :disabled="!currentUserId || isAttending(workout)" class="button" @click="bookModal(workout)" id="pameld-in-container">Påmeldt</button>
              </div>


            </div>


          </div>

          <div class="column is-one-third" id="workout-dropdown">

            <figure class="workout-image">
              <img src="../assets/yoga-300.jpg">
            </figure>


          </div>

        </div>
      </div>
      <br><br><br>
    </div>
    <hr class="explore-divider"></hr>
  </div>

  <!-- TW_FOURTH DAY -->
  <div class="container" id="explore-container" v-for="(workout, index) in workouts_sorted_time" v-if="tw_fourthday(workout) && activeDay === 'tw_Torsdag' && ((activeType === workout.type || activeType === 'all')  && (activeStudio === workout.studio.name || activeStudio === 'all'))">
    <a @click="launchActiveWorkout(workout)"  class="columns is-centered" id="explore-column">

      <div class="column"  id="workout-time">
        <th>{{workout.time}}</th>
      </div>
      <div class="column" id="workout-duration">
        <td>{{workout.duration}} min</td>
      </div>
      <div class="column" id="workout-name">
        <h1><a @click="launchActiveWorkout(workout)" id="workout-name-a">{{workout.name}}</a></h1>
      </div>
      <div class="column" id="workout-studio">
        <h1>{{workout.studio.name}}</h1>
      </div>
      <div class="column" id="workout-type">
        <td>{{workout.type}}</td>
      </div>
      <div class="column" id="workout-places">
        <td>Ledige plasser: {{workout.places_left}}</td>
      </div>
      <div class="column" id="workout-book">
        <td id="workout-book-2"><button v-if="!isAttending(workout) && workout.places_left != 0" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon">Book time</button></td>
        <td id="workout-book-2"><button v-if="isAttending(workout)" disabled class="button" id="pameld">Påmeldt</button></td> <td id="workout-book-2"><button v-if="workout.places_left === 0" disabled class="button" id="fullt">Fullt</button></td>
      </div>

    </a>


    <!-- DROPDOWN ACTIVE -->
    <div id="workout-dropdown" :class="{ 'is-hidden': workout.keyW != activeWorkout.keyW }">

      <!-- FULL INFO DROPDOWN -->
      <div class="container" id="workout-full-info">

        <!-- CENTER DESCRIPTION -->
        <div class="columns">

          <div class="column is-two-thirds" id="workout-dropdown-image">

            <h4 class="title is-4">{{activeWorkout.name}}</h4>
            <p class="subtitle is-6" id="bit-of-padding-bottom">{{activeWorkout.description}}</p>

            <h4 class="title is-5"><i class="fas fa-map-marker-alt" id="icon-location"></i> {{activeWorkout.studio.name}}</h4>
            <p class="subtitle is-6"  id="bit-of-padding-bottom">{{activeWorkout.studio.address.number}}, {{activeWorkout.studio.address.street}}, {{activeWorkout.studio.address.city}}</p>

            <!-- FACILITIES -->
            <!--<h4 class="title is-5" id="what-you-need">Hva du trenger:</h4>-->
            <!--<p v-if="activeWorkout.facilities.shower != true">Dusj</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.mat != true}">Matte</p>-->
            <!--<p v-if="activeWorkout.facilities.changingRoom != true">Garderobe</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.towel != true}"  id="bit-of-padding-bottom">Håndkle</p>-->



            <div class="columns">
              <div class="column has-text-centered">
                <button v-if="!isAttending(workout)" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon-in-container">Book time</button>
                <button v-if="isAttending(workout)" :disabled="!currentUserId || isAttending(workout)" class="button" @click="bookModal(workout)" id="pameld-in-container">Påmeldt</button>
              </div>


            </div>


          </div>

          <div class="column is-one-third" id="workout-dropdown">

            <figure class="workout-image">
              <img src="../assets/yoga-300.jpg">
            </figure>


          </div>

        </div>
      </div>
      <br><br><br>
    </div>
    <hr class="explore-divider"></hr>
  </div>

  <!-- TW_FIFTH DAY -->
  <div class="container" id="explore-container" v-for="(workout, index) in workouts_sorted_time" v-if="tw_fifthday(workout) && activeDay === 'tw_Fredag' && ((activeType === workout.type || activeType === 'all')  && (activeStudio === workout.studio.name || activeStudio === 'all'))">
    <a @click="launchActiveWorkout(workout)"  class="columns is-centered" id="explore-column">

      <div class="column"  id="workout-time">
        <th>{{workout.time}}</th>
      </div>
      <div class="column" id="workout-duration">
        <td>{{workout.duration}} min</td>
      </div>
      <div class="column" id="workout-name">
        <h1><a @click="launchActiveWorkout(workout)" id="workout-name-a">{{workout.name}}</a></h1>
      </div>
      <div class="column" id="workout-studio">
        <h1>{{workout.studio.name}}</h1>
      </div>
      <div class="column" id="workout-type">
        <td>{{workout.type}}</td>
      </div>
      <div class="column" id="workout-places">
        <td>Ledige plasser: {{workout.places_left}}</td>
      </div>
      <div class="column" id="workout-book">
        <td id="workout-book-2"><button v-if="!isAttending(workout) && workout.places_left != 0" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon">Book time</button></td>
        <td id="workout-book-2"><button v-if="isAttending(workout)" disabled class="button" id="pameld">Påmeldt</button></td> <td id="workout-book-2"><button v-if="workout.places_left === 0" disabled class="button" id="fullt">Fullt</button></td>
      </div>

    </a>


    <!-- DROPDOWN ACTIVE -->
    <div id="workout-dropdown" :class="{ 'is-hidden': workout.keyW != activeWorkout.keyW }">

      <!-- FULL INFO DROPDOWN -->
      <div class="container" id="workout-full-info">

        <!-- CENTER DESCRIPTION -->
        <div class="columns">

          <div class="column is-two-thirds" id="workout-dropdown-image">

            <h4 class="title is-4">{{activeWorkout.name}}</h4>
            <p class="subtitle is-6" id="bit-of-padding-bottom">{{activeWorkout.description}}</p>

            <h4 class="title is-5"><i class="fas fa-map-marker-alt" id="icon-location"></i> {{activeWorkout.studio.name}}</h4>
            <p class="subtitle is-6"  id="bit-of-padding-bottom">{{activeWorkout.studio.address.number}}, {{activeWorkout.studio.address.street}}, {{activeWorkout.studio.address.city}}</p>

            <!-- FACILITIES -->
            <!--<h4 class="title is-5" id="what-you-need">Hva du trenger:</h4>-->
            <!--<p v-if="activeWorkout.facilities.shower != true">Dusj</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.mat != true}">Matte</p>-->
            <!--<p v-if="activeWorkout.facilities.changingRoom != true">Garderobe</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.towel != true}"  id="bit-of-padding-bottom">Håndkle</p>-->



            <div class="columns">
              <div class="column has-text-centered">
                <button v-if="!isAttending(workout)" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon-in-container">Book time</button>
                <button v-if="isAttending(workout)" :disabled="!currentUserId || isAttending(workout)" class="button" @click="bookModal(workout)" id="pameld-in-container">Påmeldt</button>
              </div>


            </div>


          </div>

          <div class="column is-one-third" id="workout-dropdown">

            <figure class="workout-image">
              <img src="../assets/yoga-300.jpg">
            </figure>


          </div>

        </div>
      </div>
      <br><br><br>
    </div>
    <hr class="explore-divider"></hr>
  </div>

  <!-- TW_SIXTH DAY -->
  <div class="container" id="explore-container" v-for="(workout, index) in workouts_sorted_time" v-if="tw_sixthday(workout) && activeDay === 'tw_Lørdag' && ((activeType === workout.type || activeType === 'all')  && (activeStudio === workout.studio.name || activeStudio === 'all'))">
    <a @click="launchActiveWorkout(workout)"  class="columns is-centered" id="explore-column">

      <div class="column"  id="workout-time">
        <th>{{workout.time}}</th>
      </div>
      <div class="column" id="workout-duration">
        <td>{{workout.duration}} min</td>
      </div>
      <div class="column" id="workout-name">
        <h1><a @click="launchActiveWorkout(workout)" id="workout-name-a">{{workout.name}}</a></h1>
      </div>
      <div class="column" id="workout-studio">
        <h1>{{workout.studio.name}}</h1>
      </div>
      <div class="column" id="workout-type">
        <td>{{workout.type}}</td>
      </div>
      <div class="column" id="workout-places">
        <td>Ledige plasser: {{workout.places_left}}</td>
      </div>
      <div class="column" id="workout-book">
        <td id="workout-book-2"><button v-if="!isAttending(workout) && workout.places_left != 0" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon">Book time</button></td>
        <td id="workout-book-2"><button v-if="isAttending(workout)" disabled class="button" id="pameld">Påmeldt</button></td> <td id="workout-book-2"><button v-if="workout.places_left === 0" disabled class="button" id="fullt">Fullt</button></td>
      </div>

    </a>


    <!-- DROPDOWN ACTIVE -->
    <div id="workout-dropdown" :class="{ 'is-hidden': workout.keyW != activeWorkout.keyW }">

      <!-- FULL INFO DROPDOWN -->
      <div class="container" id="workout-full-info">

        <!-- CENTER DESCRIPTION -->
        <div class="columns">

          <div class="column is-two-thirds" id="workout-dropdown-image">

            <h4 class="title is-4">{{activeWorkout.name}}</h4>
            <p class="subtitle is-6" id="bit-of-padding-bottom">{{activeWorkout.description}}</p>

            <h4 class="title is-5"><i class="fas fa-map-marker-alt" id="icon-location"></i> {{activeWorkout.studio.name}}</h4>
            <p class="subtitle is-6"  id="bit-of-padding-bottom">{{activeWorkout.studio.address.number}}, {{activeWorkout.studio.address.street}}, {{activeWorkout.studio.address.city}}</p>

            <!-- FACILITIES -->
            <!--<h4 class="title is-5" id="what-you-need">Hva du trenger:</h4>-->
            <!--<p v-if="activeWorkout.facilities.shower != true">Dusj</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.mat != true}">Matte</p>-->
            <!--<p v-if="activeWorkout.facilities.changingRoom != true">Garderobe</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.towel != true}"  id="bit-of-padding-bottom">Håndkle</p>-->



            <div class="columns">
              <div class="column has-text-centered">
                <button v-if="!isAttending(workout)" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon-in-container">Book time</button>
                <button v-if="isAttending(workout)" :disabled="!currentUserId || isAttending(workout)" class="button" @click="bookModal(workout)" id="pameld-in-container">Påmeldt</button>
              </div>


            </div>


          </div>

          <div class="column is-one-third" id="workout-dropdown">

            <figure class="workout-image">
              <img src="../assets/yoga-300.jpg">
            </figure>


          </div>

        </div>
      </div>
      <br><br><br>
    </div>
    <hr class="explore-divider"></hr>
  </div>

  <!-- TW_SEVENTH DAY -->
  <div class="container" id="explore-container" v-for="(workout, index) in workouts_sorted_time" v-if="tw_seventhday(workout) && activeDay === 'tw_Søndag' && ((activeType === workout.type || activeType === 'all')  && (activeStudio === workout.studio.name || activeStudio === 'all'))">
    <a @click="launchActiveWorkout(workout)"  class="columns is-centered" id="explore-column">

      <div class="column"  id="workout-time">
        <th>{{workout.time}}</th>
      </div>
      <div class="column" id="workout-duration">
        <td>{{workout.duration}} min</td>
      </div>
      <div class="column" id="workout-name">
        <h1><a @click="launchActiveWorkout(workout)" id="workout-name-a">{{workout.name}}</a></h1>
      </div>
      <div class="column" id="workout-studio">
        <h1>{{workout.studio.name}}</h1>
      </div>
      <div class="column" id="workout-type">
        <td>{{workout.type}}</td>
      </div>
      <div class="column" id="workout-places">
        <td>Ledige plasser: {{workout.places_left}}</td>
      </div>
      <div class="column" id="workout-book">
        <td id="workout-book-2"><button v-if="!isAttending(workout) && workout.places_left != 0" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon">Book time</button></td>
        <td id="workout-book-2"><button v-if="isAttending(workout)" disabled class="button" id="pameld">Påmeldt</button></td> <td id="workout-book-2"><button v-if="workout.places_left === 0" disabled class="button" id="fullt">Fullt</button></td>
      </div>

    </a>


    <!-- DROPDOWN ACTIVE -->
    <div id="workout-dropdown" :class="{ 'is-hidden': workout.keyW != activeWorkout.keyW }">

      <!-- FULL INFO DROPDOWN -->
      <div class="container" id="workout-full-info">

        <!-- CENTER DESCRIPTION -->
        <div class="columns">

          <div class="column is-two-thirds" id="workout-dropdown-image">

            <h4 class="title is-4">{{activeWorkout.name}}</h4>
            <p class="subtitle is-6" id="bit-of-padding-bottom">{{activeWorkout.description}}</p>

            <h4 class="title is-5"><i class="fas fa-map-marker-alt" id="icon-location"></i> {{activeWorkout.studio.name}}</h4>
            <p class="subtitle is-6"  id="bit-of-padding-bottom">{{activeWorkout.studio.address.number}}, {{activeWorkout.studio.address.street}}, {{activeWorkout.studio.address.city}}</p>

            <!-- FACILITIES -->
            <!--<h4 class="title is-5" id="what-you-need">Hva du trenger:</h4>-->
            <!--<p v-if="activeWorkout.facilities.shower != true">Dusj</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.mat != true}">Matte</p>-->
            <!--<p v-if="activeWorkout.facilities.changingRoom != true">Garderobe</p>-->
            <!--<p :class="{'is-hidden' : activeWorkout.facilities.towel != true}"  id="bit-of-padding-bottom">Håndkle</p>-->



            <div class="columns">
              <div class="column has-text-centered">
                <button v-if="!isAttending(workout)" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon-in-container">Book time</button>
                <button v-if="isAttending(workout)" :disabled="!currentUserId || isAttending(workout)" class="button" @click="bookModal(workout)" id="pameld-in-container">Påmeldt</button>
              </div>


            </div>


          </div>

          <div class="column is-one-third" id="workout-dropdown">

            <figure class="workout-image">
              <img src="../assets/yoga-300.jpg">
            </figure>


          </div>

        </div>
      </div>
      <br><br><br>
    </div>
    <hr class="explore-divider"></hr>
  </div>
<!--FOURTH WEEK -->
  <!-- FW_FIRST DAY -->
  <div class="container" id="explore-container" v-for="(workout, index) in workouts_sorted_time" v-if="(fw_today(workout) && activeDay === 'fw_Mandag') && ((activeType === workout.type || activeType === 'all')  && (activeStudio === workout.studio.name || activeStudio === 'all'))">
      <a @click="launchActiveWorkout(workout)"  class="columns is-centered" id="explore-column">

        <div class="column"  id="workout-time">
          <th>{{workout.time}}</th>
        </div>
        <div class="column" id="workout-duration">
          <td>{{workout.duration}} min</td>
        </div>
        <div class="column" id="workout-name">
          <h1><a @click="launchActiveWorkout(workout)" id="workout-name-a">{{workout.name}}</a></h1>
        </div>
        <div class="column" id="workout-studio">
          <h1>{{workout.studio.name}}</h1>
        </div>
        <div class="column" id="workout-type">
          <td>{{workout.type}}</td>
        </div>
        <div class="column" id="workout-places">
          <td>Ledige plasser: {{workout.places_left}}</td>
        </div>
        <div class="column" id="workout-book">
          <td id="workout-book-2"><button v-if="!isAttending(workout) && workout.places_left != 0" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon">Book time</button></td>
          <td id="workout-book-2"><button v-if="isAttending(workout)" disabled class="button" id="pameld">Påmeldt</button></td> <td id="workout-book-2"><button v-if="workout.places_left === 0" disabled class="button" id="fullt">Fullt</button></td>
        </div>

      </a>


      <!-- DROPDOWN ACTIVE -->
      <div id="workout-dropdown" :class="{ 'is-hidden': workout.keyW != activeWorkout.keyW }">

        <!-- FULL INFO DROPDOWN -->
        <div class="container" id="workout-full-info">

          <!-- CENTER DESCRIPTION -->
          <div class="columns">

            <div class="column is-two-thirds" id="workout-dropdown-image">

              <h4 class="title is-4">{{activeWorkout.name}}</h4>
              <p class="subtitle is-6" id="bit-of-padding-bottom">{{activeWorkout.description}}</p>

              <h4 class="title is-5"><i class="fas fa-map-marker-alt" id="icon-location"></i> {{activeWorkout.studio.name}}</h4>
              <p class="subtitle is-6"  id="bit-of-padding-bottom">{{activeWorkout.studio.address.number}}, {{activeWorkout.studio.address.street}}, {{activeWorkout.studio.address.city}}</p>

              <!-- FACILITIES -->
              <!--<h4 class="title is-5" id="what-you-need">Hva du trenger:</h4>-->
              <!--<p v-if="activeWorkout.facilities.shower != true">Dusj</p>-->
              <!--<p :class="{'is-hidden' : activeWorkout.facilities.mat != true}">Matte</p>-->
              <!--<p v-if="activeWorkout.facilities.changingRoom != true">Garderobe</p>-->
              <!--<p :class="{'is-hidden' : activeWorkout.facilities.towel != true}"  id="bit-of-padding-bottom">Håndkle</p>-->



              <div class="columns">
                <div class="column has-text-centered">
                  <button v-if="!isAttending(workout)" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon-in-container">Book time</button>
                  <button v-if="isAttending(workout)" :disabled="!currentUserId || isAttending(workout)" class="button" @click="bookModal(workout)" id="pameld-in-container">Påmeldt</button>
                </div>


              </div>


            </div>

            <div class="column is-one-third" id="workout-dropdown">

              <figure class="workout-image">
                <img src="../assets/yoga-300.jpg">
              </figure>


            </div>

          </div>
        </div>
        <br><br><br>
      </div>
      <hr class="explore-divider"></hr>
    </div>

  <!-- FW_SECOND DAY -->
  <div class="container" id="explore-container" v-for="(workout, index) in workouts_sorted_time" v-if="fw_tomorrow(workout) && activeDay === 'fw_Tirsdag' && ((activeType === workout.type || activeType === 'all')  && (activeStudio === workout.studio.name || activeStudio === 'all'))">
      <a @click="launchActiveWorkout(workout)"  class="columns is-centered" id="explore-column">

        <div class="column"  id="workout-time">
          <th>{{workout.time}}</th>
        </div>
        <div class="column" id="workout-duration">
          <td>{{workout.duration}} min</td>
        </div>
        <div class="column" id="workout-name">
          <h1><a @click="launchActiveWorkout(workout)" id="workout-name-a">{{workout.name}}</a></h1>
        </div>
        <div class="column" id="workout-studio">
          <h1>{{workout.studio.name}}</h1>
        </div>
        <div class="column" id="workout-type">
          <td>{{workout.type}}</td>
        </div>
        <div class="column" id="workout-places">
          <td>Ledige plasser: {{workout.places_left}}</td>
        </div>
        <div class="column" id="workout-book">
          <td id="workout-book-2"><button v-if="!isAttending(workout) && workout.places_left != 0" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon">Book time</button></td>
          <td id="workout-book-2"><button v-if="isAttending(workout)" disabled class="button" id="pameld">Påmeldt</button></td> <td id="workout-book-2"><button v-if="workout.places_left === 0" disabled class="button" id="fullt">Fullt</button></td>
        </div>

      </a>


      <!-- DROPDOWN ACTIVE -->
      <div id="workout-dropdown" :class="{ 'is-hidden': workout.keyW != activeWorkout.keyW }">

        <!-- FULL INFO DROPDOWN -->
        <div class="container" id="workout-full-info">

          <!-- CENTER DESCRIPTION -->
          <div class="columns">

            <div class="column is-two-thirds" id="workout-dropdown-image">

              <h4 class="title is-4">{{activeWorkout.name}}</h4>
              <p class="subtitle is-6" id="bit-of-padding-bottom">{{activeWorkout.description}}</p>

              <h4 class="title is-5"><i class="fas fa-map-marker-alt" id="icon-location"></i> {{activeWorkout.studio.name}}</h4>
              <p class="subtitle is-6"  id="bit-of-padding-bottom">{{activeWorkout.studio.address.number}}, {{activeWorkout.studio.address.street}}, {{activeWorkout.studio.address.city}}</p>

              <!-- FACILITIES -->
              <!--<h4 class="title is-5" id="what-you-need">Hva du trenger:</h4>-->
              <!--<p v-if="activeWorkout.facilities.shower != true">Dusj</p>-->
              <!--<p :class="{'is-hidden' : activeWorkout.facilities.mat != true}">Matte</p>-->
              <!--<p v-if="activeWorkout.facilities.changingRoom != true">Garderobe</p>-->
              <!--<p :class="{'is-hidden' : activeWorkout.facilities.towel != true}"  id="bit-of-padding-bottom">Håndkle</p>-->



              <div class="columns">
                <div class="column has-text-centered">
                  <button v-if="!isAttending(workout)" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon-in-container">Book time</button>
                  <button v-if="isAttending(workout)" :disabled="!currentUserId || isAttending(workout)" class="button" @click="bookModal(workout)" id="pameld-in-container">Påmeldt</button>
                </div>


              </div>


            </div>

            <div class="column is-one-third" id="workout-dropdown">

              <figure class="workout-image">
                <img src="../assets/yoga-300.jpg">
              </figure>


            </div>

          </div>
        </div>
        <br><br><br>
      </div>
      <hr class="explore-divider"></hr>
    </div>

  <!-- FW_THIRD DAY -->
  <div class="container" id="explore-container" v-for="(workout, index) in workouts_sorted_time" v-if="fw_thirdday(workout) && activeDay === 'fw_Onsdag' && ((activeType === workout.type || activeType === 'all')  && (activeStudio === workout.studio.name || activeStudio === 'all'))">
      <a @click="launchActiveWorkout(workout)"  class="columns is-centered" id="explore-column">

        <div class="column"  id="workout-time">
          <th>{{workout.time}}</th>
        </div>
        <div class="column" id="workout-duration">
          <td>{{workout.duration}} min</td>
        </div>
        <div class="column" id="workout-name">
          <h1><a @click="launchActiveWorkout(workout)" id="workout-name-a">{{workout.name}}</a></h1>
        </div>
        <div class="column" id="workout-studio">
          <h1>{{workout.studio.name}}</h1>
        </div>
        <div class="column" id="workout-type">
          <td>{{workout.type}}</td>
        </div>
        <div class="column" id="workout-places">
          <td>Ledige plasser: {{workout.places_left}}</td>
        </div>
        <div class="column" id="workout-book">
          <td id="workout-book-2"><button v-if="!isAttending(workout) && workout.places_left != 0" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon">Book time</button></td>
          <td id="workout-book-2"><button v-if="isAttending(workout)" disabled class="button" id="pameld">Påmeldt</button></td> <td id="workout-book-2"><button v-if="workout.places_left === 0" disabled class="button" id="fullt">Fullt</button></td>
        </div>

      </a>


      <!-- DROPDOWN ACTIVE -->
      <div id="workout-dropdown" :class="{ 'is-hidden': workout.keyW != activeWorkout.keyW }">

        <!-- FULL INFO DROPDOWN -->
        <div class="container" id="workout-full-info">

          <!-- CENTER DESCRIPTION -->
          <div class="columns">

            <div class="column is-two-thirds" id="workout-dropdown-image">

              <h4 class="title is-4">{{activeWorkout.name}}</h4>
              <p class="subtitle is-6" id="bit-of-padding-bottom">{{activeWorkout.description}}</p>

              <h4 class="title is-5"><i class="fas fa-map-marker-alt" id="icon-location"></i> {{activeWorkout.studio.name}}</h4>
              <p class="subtitle is-6"  id="bit-of-padding-bottom">{{activeWorkout.studio.address.number}}, {{activeWorkout.studio.address.street}}, {{activeWorkout.studio.address.city}}</p>

              <!-- FACILITIES -->
              <!--<h4 class="title is-5" id="what-you-need">Hva du trenger:</h4>-->
              <!--<p v-if="activeWorkout.facilities.shower != true">Dusj</p>-->
              <!--<p :class="{'is-hidden' : activeWorkout.facilities.mat != true}">Matte</p>-->
              <!--<p v-if="activeWorkout.facilities.changingRoom != true">Garderobe</p>-->
              <!--<p :class="{'is-hidden' : activeWorkout.facilities.towel != true}"  id="bit-of-padding-bottom">Håndkle</p>-->



              <div class="columns">
                <div class="column has-text-centered">
                  <button v-if="!isAttending(workout)" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon-in-container">Book time</button>
                  <button v-if="isAttending(workout)" :disabled="!currentUserId || isAttending(workout)" class="button" @click="bookModal(workout)" id="pameld-in-container">Påmeldt</button>
                </div>


              </div>


            </div>

            <div class="column is-one-third" id="workout-dropdown">

              <figure class="workout-image">
                <img src="../assets/yoga-300.jpg">
              </figure>


            </div>

          </div>
        </div>
        <br><br><br>
      </div>
      <hr class="explore-divider"></hr>
    </div>

  <!-- FW_FOURTH DAY -->
  <div class="container" id="explore-container" v-for="(workout, index) in workouts_sorted_time" v-if="fw_fourthday(workout) && activeDay === 'fw_Torsdag' && ((activeType === workout.type || activeType === 'all')  && (activeStudio === workout.studio.name || activeStudio === 'all'))">
      <a @click="launchActiveWorkout(workout)"  class="columns is-centered" id="explore-column">

        <div class="column"  id="workout-time">
          <th>{{workout.time}}</th>
        </div>
        <div class="column" id="workout-duration">
          <td>{{workout.duration}} min</td>
        </div>
        <div class="column" id="workout-name">
          <h1><a @click="launchActiveWorkout(workout)" id="workout-name-a">{{workout.name}}</a></h1>
        </div>
        <div class="column" id="workout-studio">
          <h1>{{workout.studio.name}}</h1>
        </div>
        <div class="column" id="workout-type">
          <td>{{workout.type}}</td>
        </div>
        <div class="column" id="workout-places">
          <td>Ledige plasser: {{workout.places_left}}</td>
        </div>
        <div class="column" id="workout-book">
          <td id="workout-book-2"><button v-if="!isAttending(workout) && workout.places_left != 0" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon">Book time</button></td>
          <td id="workout-book-2"><button v-if="isAttending(workout)" disabled class="button" id="pameld">Påmeldt</button></td> <td id="workout-book-2"><button v-if="workout.places_left === 0" disabled class="button" id="fullt">Fullt</button></td>
        </div>

      </a>


      <!-- DROPDOWN ACTIVE -->
      <div id="workout-dropdown" :class="{ 'is-hidden': workout.keyW != activeWorkout.keyW }">

        <!-- FULL INFO DROPDOWN -->
        <div class="container" id="workout-full-info">

          <!-- CENTER DESCRIPTION -->
          <div class="columns">

            <div class="column is-two-thirds" id="workout-dropdown-image">

              <h4 class="title is-4">{{activeWorkout.name}}</h4>
              <p class="subtitle is-6" id="bit-of-padding-bottom">{{activeWorkout.description}}</p>

              <h4 class="title is-5"><i class="fas fa-map-marker-alt" id="icon-location"></i> {{activeWorkout.studio.name}}</h4>
              <p class="subtitle is-6"  id="bit-of-padding-bottom">{{activeWorkout.studio.address.number}}, {{activeWorkout.studio.address.street}}, {{activeWorkout.studio.address.city}}</p>

              <!-- FACILITIES -->
              <!--<h4 class="title is-5" id="what-you-need">Hva du trenger:</h4>-->
              <!--<p v-if="activeWorkout.facilities.shower != true">Dusj</p>-->
              <!--<p :class="{'is-hidden' : activeWorkout.facilities.mat != true}">Matte</p>-->
              <!--<p v-if="activeWorkout.facilities.changingRoom != true">Garderobe</p>-->
              <!--<p :class="{'is-hidden' : activeWorkout.facilities.towel != true}"  id="bit-of-padding-bottom">Håndkle</p>-->



              <div class="columns">
                <div class="column has-text-centered">
                  <button v-if="!isAttending(workout)" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon-in-container">Book time</button>
                  <button v-if="isAttending(workout)" :disabled="!currentUserId || isAttending(workout)" class="button" @click="bookModal(workout)" id="pameld-in-container">Påmeldt</button>
                </div>


              </div>


            </div>

            <div class="column is-one-third" id="workout-dropdown">

              <figure class="workout-image">
                <img src="../assets/yoga-300.jpg">
              </figure>


            </div>

          </div>
        </div>
        <br><br><br>
      </div>
      <hr class="explore-divider"></hr>
    </div>

  <!-- FW_FIFTH DAY -->
  <div class="container" id="explore-container" v-for="(workout, index) in workouts_sorted_time" v-if="fw_fifthday(workout) && activeDay === 'fw_Fredag' && ((activeType === workout.type || activeType === 'all')  && (activeStudio === workout.studio.name || activeStudio === 'all'))">
      <a @click="launchActiveWorkout(workout)"  class="columns is-centered" id="explore-column">

        <div class="column"  id="workout-time">
          <th>{{workout.time}}</th>
        </div>
        <div class="column" id="workout-duration">
          <td>{{workout.duration}} min</td>
        </div>
        <div class="column" id="workout-name">
          <h1><a @click="launchActiveWorkout(workout)" id="workout-name-a">{{workout.name}}</a></h1>
        </div>
        <div class="column" id="workout-studio">
          <h1>{{workout.studio.name}}</h1>
        </div>
        <div class="column" id="workout-type">
          <td>{{workout.type}}</td>
        </div>
        <div class="column" id="workout-places">
          <td>Ledige plasser: {{workout.places_left}}</td>
        </div>
        <div class="column" id="workout-book">
          <td id="workout-book-2"><button v-if="!isAttending(workout) && workout.places_left != 0" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon">Book time</button></td>
          <td id="workout-book-2"><button v-if="isAttending(workout)" disabled class="button" id="pameld">Påmeldt</button></td> <td id="workout-book-2"><button v-if="workout.places_left === 0" disabled class="button" id="fullt">Fullt</button></td>
        </div>

      </a>


      <!-- DROPDOWN ACTIVE -->
      <div id="workout-dropdown" :class="{ 'is-hidden': workout.keyW != activeWorkout.keyW }">

        <!-- FULL INFO DROPDOWN -->
        <div class="container" id="workout-full-info">

          <!-- CENTER DESCRIPTION -->
          <div class="columns">

            <div class="column is-two-thirds" id="workout-dropdown-image">

              <h4 class="title is-4">{{activeWorkout.name}}</h4>
              <p class="subtitle is-6" id="bit-of-padding-bottom">{{activeWorkout.description}}</p>

              <h4 class="title is-5"><i class="fas fa-map-marker-alt" id="icon-location"></i> {{activeWorkout.studio.name}}</h4>
              <p class="subtitle is-6"  id="bit-of-padding-bottom">{{activeWorkout.studio.address.number}}, {{activeWorkout.studio.address.street}}, {{activeWorkout.studio.address.city}}</p>

              <!-- FACILITIES -->
              <!--<h4 class="title is-5" id="what-you-need">Hva du trenger:</h4>-->
              <!--<p v-if="activeWorkout.facilities.shower != true">Dusj</p>-->
              <!--<p :class="{'is-hidden' : activeWorkout.facilities.mat != true}">Matte</p>-->
              <!--<p v-if="activeWorkout.facilities.changingRoom != true">Garderobe</p>-->
              <!--<p :class="{'is-hidden' : activeWorkout.facilities.towel != true}"  id="bit-of-padding-bottom">Håndkle</p>-->



              <div class="columns">
                <div class="column has-text-centered">
                  <button v-if="!isAttending(workout)" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon-in-container">Book time</button>
                  <button v-if="isAttending(workout)" :disabled="!currentUserId || isAttending(workout)" class="button" @click="bookModal(workout)" id="pameld-in-container">Påmeldt</button>
                </div>


              </div>


            </div>

            <div class="column is-one-third" id="workout-dropdown">

              <figure class="workout-image">
                <img src="../assets/yoga-300.jpg">
              </figure>


            </div>

          </div>
        </div>
        <br><br><br>
      </div>
      <hr class="explore-divider"></hr>
    </div>

  <!-- FW_SIXTH DAY -->
  <div class="container" id="explore-container" v-for="(workout, index) in workouts_sorted_time" v-if="fw_sixthday(workout) && activeDay === 'fw_Lørdag' && ((activeType === workout.type || activeType === 'all')  && (activeStudio === workout.studio.name || activeStudio === 'all'))">
      <a @click="launchActiveWorkout(workout)"  class="columns is-centered" id="explore-column">

        <div class="column"  id="workout-time">
          <th>{{workout.time}}</th>
        </div>
        <div class="column" id="workout-duration">
          <td>{{workout.duration}} min</td>
        </div>
        <div class="column" id="workout-name">
          <h1><a @click="launchActiveWorkout(workout)" id="workout-name-a">{{workout.name}}</a></h1>
        </div>
        <div class="column" id="workout-studio">
          <h1>{{workout.studio.name}}</h1>
        </div>
        <div class="column" id="workout-type">
          <td>{{workout.type}}</td>
        </div>
        <div class="column" id="workout-places">
          <td>Ledige plasser: {{workout.places_left}}</td>
        </div>
        <div class="column" id="workout-book">
          <td id="workout-book-2"><button v-if="!isAttending(workout) && workout.places_left != 0" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon">Book time</button></td>
          <td id="workout-book-2"><button v-if="isAttending(workout)" disabled class="button" id="pameld">Påmeldt</button></td> <td id="workout-book-2"><button v-if="workout.places_left === 0" disabled class="button" id="fullt">Fullt</button></td>
        </div>

      </a>


      <!-- DROPDOWN ACTIVE -->
      <div id="workout-dropdown" :class="{ 'is-hidden': workout.keyW != activeWorkout.keyW }">

        <!-- FULL INFO DROPDOWN -->
        <div class="container" id="workout-full-info">

          <!-- CENTER DESCRIPTION -->
          <div class="columns">

            <div class="column is-two-thirds" id="workout-dropdown-image">

              <h4 class="title is-4">{{activeWorkout.name}}</h4>
              <p class="subtitle is-6" id="bit-of-padding-bottom">{{activeWorkout.description}}</p>

              <h4 class="title is-5"><i class="fas fa-map-marker-alt" id="icon-location"></i> {{activeWorkout.studio.name}}</h4>
              <p class="subtitle is-6"  id="bit-of-padding-bottom">{{activeWorkout.studio.address.number}}, {{activeWorkout.studio.address.street}}, {{activeWorkout.studio.address.city}}</p>

              <!-- FACILITIES -->
              <!--<h4 class="title is-5" id="what-you-need">Hva du trenger:</h4>-->
              <!--<p v-if="activeWorkout.facilities.shower != true">Dusj</p>-->
              <!--<p :class="{'is-hidden' : activeWorkout.facilities.mat != true}">Matte</p>-->
              <!--<p v-if="activeWorkout.facilities.changingRoom != true">Garderobe</p>-->
              <!--<p :class="{'is-hidden' : activeWorkout.facilities.towel != true}"  id="bit-of-padding-bottom">Håndkle</p>-->



              <div class="columns">
                <div class="column has-text-centered">
                  <button v-if="!isAttending(workout)" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon-in-container">Book time</button>
                  <button v-if="isAttending(workout)" :disabled="!currentUserId || isAttending(workout)" class="button" @click="bookModal(workout)" id="pameld-in-container">Påmeldt</button>
                </div>


              </div>


            </div>

            <div class="column is-one-third" id="workout-dropdown">

              <figure class="workout-image">
                <img src="../assets/yoga-300.jpg">
              </figure>


            </div>

          </div>
        </div>
        <br><br><br>
      </div>
      <hr class="explore-divider"></hr>
    </div>

  <!-- FW_SEVENTH DAY -->
  <div class="container" id="explore-container" v-for="(workout, index) in workouts_sorted_time" v-if="fw_seventhday(workout) && activeDay === 'fw_Søndag' && ((activeType === workout.type || activeType === 'all')  && (activeStudio === workout.studio.name || activeStudio === 'all'))">
      <a @click="launchActiveWorkout(workout)"  class="columns is-centered" id="explore-column">

        <div class="column"  id="workout-time">
          <th>{{workout.time}}</th>
        </div>
        <div class="column" id="workout-duration">
          <td>{{workout.duration}} min</td>
        </div>
        <div class="column" id="workout-name">
          <h1><a @click="launchActiveWorkout(workout)" id="workout-name-a">{{workout.name}}</a></h1>
        </div>
        <div class="column" id="workout-studio">
          <h1>{{workout.studio.name}}</h1>
        </div>
        <div class="column" id="workout-type">
          <td>{{workout.type}}</td>
        </div>
        <div class="column" id="workout-places">
          <td>Ledige plasser: {{workout.places_left}}</td>
        </div>
        <div class="column" id="workout-book">
          <td id="workout-book-2"><button v-if="!isAttending(workout) && workout.places_left != 0" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon">Book time</button></td>
          <td id="workout-book-2"><button v-if="isAttending(workout)" disabled class="button" id="pameld">Påmeldt</button></td> <td id="workout-book-2"><button v-if="workout.places_left === 0" disabled class="button" id="fullt">Fullt</button></td>
        </div>

      </a>


      <!-- DROPDOWN ACTIVE -->
      <div id="workout-dropdown" :class="{ 'is-hidden': workout.keyW != activeWorkout.keyW }">

        <!-- FULL INFO DROPDOWN -->
        <div class="container" id="workout-full-info">

          <!-- CENTER DESCRIPTION -->
          <div class="columns">

            <div class="column is-two-thirds" id="workout-dropdown-image">

              <h4 class="title is-4">{{activeWorkout.name}}</h4>
              <p class="subtitle is-6" id="bit-of-padding-bottom">{{activeWorkout.description}}</p>

              <h4 class="title is-5"><i class="fas fa-map-marker-alt" id="icon-location"></i> {{activeWorkout.studio.name}}</h4>
              <p class="subtitle is-6"  id="bit-of-padding-bottom">{{activeWorkout.studio.address.number}}, {{activeWorkout.studio.address.street}}, {{activeWorkout.studio.address.city}}</p>

              <!-- FACILITIES -->
              <!--<h4 class="title is-5" id="what-you-need">Hva du trenger:</h4>-->
              <!--<p v-if="activeWorkout.facilities.shower != true">Dusj</p>-->
              <!--<p :class="{'is-hidden' : activeWorkout.facilities.mat != true}">Matte</p>-->
              <!--<p v-if="activeWorkout.facilities.changingRoom != true">Garderobe</p>-->
              <!--<p :class="{'is-hidden' : activeWorkout.facilities.towel != true}"  id="bit-of-padding-bottom">Håndkle</p>-->



              <div class="columns">
                <div class="column has-text-centered">
                  <button v-if="!isAttending(workout)" :disabled="!currentUserId" class="button" @click="bookModal(workout)" id="meldon-in-container">Book time</button>
                  <button v-if="isAttending(workout)" :disabled="!currentUserId || isAttending(workout)" class="button" @click="bookModal(workout)" id="pameld-in-container">Påmeldt</button>
                </div>


              </div>


            </div>

            <div class="column is-one-third" id="workout-dropdown">

              <figure class="workout-image">
                <img src="../assets/yoga-300.jpg">
              </figure>


            </div>

          </div>
        </div>
        <br><br><br>
      </div>
      <hr class="explore-divider"></hr>
    </div>



</div>


<!-- BOOKING CONFIRMED MODAL -->

<div class="modal" :class="{'is-active' : bookedModal}">
  <div class="modal-background" @click="bookedModal = false"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title has-text-centered">Vi gleder oss til å se deg på timen!</p>
      <button class="delete" @click="bookedModal = false" aria-label="close"></button>
    </header>
    <section class="modal-card-body">
      <h4 class="title is-4">{{bookedWorkout.name}}</h4>
      <h4 class="title is-5">Sted: {{bookedWorkout.studio.name}}</h4>
      <h4 class="title is-5">Dato: {{bookedWorkout.date | formatDate}}</h4>
      <h4 class="title is-5">Tid: {{bookedWorkout.time}}</h4>

    </section>
  </div>
</div>

<div class="modal" :class="{ 'is-active': bookModalShow}">
  <div class="modal-background" @click="bookModalShow = false"></div>
  <div class="modal-card">
    <section class="modal-card-body">
      <h1 class="title is-4">Er du sikker på at du vil melde deg på timen?</h1>
      <button @click="bookClass()" class="button is-success unbook-btn">Meld på</button>
      <button @click="bookModalShow = false" class="button is-neutral unbook-btn">Avbryt</button>
    </section>
  </div>
</div>


</section>
</template>

<script>
import Firebase from 'firebase'


export default {


  data() {
    return {

      currentUserId: null,

      activeType: 'Alle',
      activeDay: 'Mandag',
      activeDate: '',

      dateNumber: '',
      dateNumberTomorrow: '',
      dateNumberThirdday: '',
      dateNumberFourthday: '',
      dateNumberFifthday: '',
      dateNumberSixthday: '',
      dateNumberSeventhday: '',
      day: '',

      showDeleteModal: false,
      toDelete: '',

      activeWorkout: {
        name: '',
        time: '',
        duration: '',
        date: '',
        studio: {
          name: '',
          address: {
            street: '',
            number: '',
            city: '',
          },
        },
        description: '',
        places_left: '',
        type: '',
        attendees: '',
        keyW: '',
        facilities: {
          shower: false,
          mat: false,
          towel: false,
          changingRoom: false,
        },
        suitableFor: {
          beginner: false,
          intermediate: false,
          advanced: false,
        },
        intensity: '',

      },

      bookedModal: false,
      bookedWorkout: {
        name: '',
        time: '',
        duration: '',
        date: '',
        studio: {
          name: '',
          address: {
            street: '',
            number: '',
            city: '',
          },
        },
        description: '',
        places_left: '',
        type: '',
        attendees: '',
        keyW: '',
        facilities: {
          shower: false,
          mat: false,
          towel: false,
          changingRoom: false,
        },
        suitableFor: {
          beginner: false,
          intermediate: false,
          advanced: false,
        },
        intensity: '',

      },

      studioDropdown: false,
      activeStudio: 'all',
      dropdownStudioName: 'Velg studio',

      typeDropdown: false,
      activeType: 'all',
      dropdownTypeName: 'Velg trening',

      isSelected: false,

      /*      activeStudio: {
      name: '',
      facilities: {
      shower: '',
      address: '',
      mat: '',
    },
    address: '',
    mapURL: '',
  }, */


  userAlreadySignedup: false,

  activeWeek: 'firstWeek',

  workouts: [],
  studios: [],

  test_workouts: {},

  bookModalShow: false,
  toBook: '',
}
},

methods: {
  bookModal: function(workout) {
    this.bookModalShow = true;

    this.toBook = workout;
  },
  isAttending: function(workout) {
    if(Firebase.auth().currentUser.uid != null) {var currentUserId = Firebase.auth().currentUser.uid};
    if(workout.attendees.hasOwnProperty(currentUserId)) {return true}
    else {return false};
  },
  isActiveWorkout: function(workout){
    if (workout.keyW === this.activeWorkout.keyW) {
      return true;
    } else {return false}
  },
  dropdownIsSelected: function(which){
    if(which === 'studio'){
      if (this.activeStudio != 'all') {return true}
      else {return false}
    } else {
      if (this.activeType != 'all') {return true}
      else {return false}
    }
  },
  setActiveStudio: function(studio) {
    this.activeStudio = studio;
    if (this.activeStudio === 'all') {
      this.dropdownStudioName = 'Velg studio'
    } else { this.dropdownStudioName = this.activeStudio };
  },
  activateStudioDropdown: function() {
    if (this.studioDropdown === false) {
      this.studioDropdown = true;
    } else {
      this.studioDropdown = false;
    };
    if(this.typeDropdown === true) {this.typeDropdown = false};
  },
  activateTypeDropdown: function() {
    if (this.typeDropdown === false) {
      this.typeDropdown = true;
    } else {
      this.typeDropdown = false;
    };
    if(this.studioDropdown === true) {this.studioDropdown = false};
  },
  bookClass: function(){

    var wo = Firebase.database().ref('workouts/'+this.toBook.keyW);

    if(this.toBook.places_left >= 1) {
      var new_places = this.toBook.places_left - 1;

      Firebase.database().ref('users/'+this.currentUserId).on('value', snapshot => {
        var user = snapshot.val();
        var firstName = user.firstName;
        var lastName = user.lastName;
        var fullName = `${firstName} ${lastName}`;

        var bookRef = Firebase.database().ref('workouts/'+this.toBook.keyW+'/attendees/'+this.currentUserId);
        bookRef.set(fullName);
      });

      var userRef = Firebase.database().ref('users/'+this.currentUserId+'/workoutsAttended/'+this.toBook.keyW);
      userRef.set(this.toBook);

      this.bookModalShow = false;
      this.bookedWorkout = this.toBook;
      this.bookedModal = true;

    } else {alert("Ingen ledige plasser!")};
      wo.update({places_left: new_places});

  },
  launchActiveWorkout: function(workout){
    if(this.activeWorkout.keyW === workout.keyW) {
      console.log('to_fix')
    }
    else {this.activeWorkout = workout};

  },
  closeActiveWorkout: function(workout){
    this.activeWorkout = [];
  },
  isActiveWeek: function(week){
    return this.activeWeek === week
  },
  nextWeek: function(){
    if(this.activeWeek === 'firstWeek') {this.activeWeek = 'secondWeek'; this.activeDay = 'sw_Mandag'}
    else if(this.activeWeek ==='secondWeek') {this.activeWeek = 'thirdWeek'; this.activeDay = 'tw_Mandag'}
    else if(this.activeWeek ==='thirdWeek') {this.activeWeek = 'fourthWeek'; this.activeDay = 'fw_Mandag'}
     else {alert("Already at last week!")}
  },
  previousWeek: function (){
    if(this.activeWeek === 'firstWeek') {alert("Already at first week!")}
    else if(this.activeWeek ==='secondWeek') {this.activeWeek = 'firstWeek'; this.activeDay = 'Mandag'}
    else if(this.activeWeek ==='thirdWeek') {this.activeWeek = 'secondWeek'; this.activeDay = 'sw_Mandag'}
    else if(this.activeWeek ==='fourthWeek') {this.activeWeek = 'thirdWeek'; this.activeDay = 'tw_Mandag'}

   },
  activateDeleteModal: function(index) {
    this.showDeleteModal = true;
    this.toDelete = index;
  },
  deleteClass: function() {
    var wo = Firebase.database().ref('workouts/'+this.toDelete);
    wo.remove();
    this.showDeleteModal = false;
  },

  removeWorkout: function (index) {
    var wo = Firebase.database().ref('workouts/'+index);
    wo.remove();
  },
  today: function(workout) {
    var date = new Date();
    var dd = date.getDate();
    var mm = date.getMonth()+1;
    var yyyy = date.getFullYear();
    if (mm < 10) {mm = '0'+mm};
    if (dd < 10) {dd = '0'+dd};
    var todaysDate = yyyy+'-'+mm+'-'+dd;

    if(workout.date === todaysDate) { return true };
  },
  tomorrow: function(workout) {
    var date = new Date();
    date.setDate(date.getDate()+1);
    var dd = date.getDate();
    var mm = date.getMonth()+1;
    var yyyy = date.getFullYear();
    if (mm < 10) {mm = '0'+mm};
    if (dd < 10) {dd = '0'+dd};
    var tomorrowsDate = yyyy+'-'+mm+'-'+dd;

    if(workout.date === tomorrowsDate) { return true };
  },
  thirdday: function(workout) {
    var date = new Date();
    date.setDate(date.getDate()+2);
    var dd = date.getDate();
    var mm = date.getMonth()+1;
    var yyyy = date.getFullYear();
    if (mm < 10) {mm = '0'+mm};
    if (dd < 10) {dd = '0'+dd};
    var thirddayDate = yyyy+'-'+mm+'-'+dd;

    if(workout.date === thirddayDate) { return true };
  },
  fourthday: function(workout) {
    var date = new Date();
    date.setDate(date.getDate()+3);
    var dd = date.getDate();
    var mm = date.getMonth()+1;
    var yyyy = date.getFullYear();
    if (mm < 10) {mm = '0'+mm};
    if (dd < 10) {dd = '0'+dd};
    var fourthdayDate = yyyy+'-'+mm+'-'+dd;

    if(workout.date === fourthdayDate) { return true };
  },
  fifthday: function(workout) {
    var date = new Date();
    date.setDate(date.getDate()+4);
    var dd = date.getDate();
    var mm = date.getMonth()+1;
    var yyyy = date.getFullYear();
    if (mm < 10) {mm = '0'+mm};
    if (dd < 10) {dd = '0'+dd};
    var fifthdayDate = yyyy+'-'+mm+'-'+dd;

    if(workout.date === fifthdayDate) { return true };
  },
  sixthday: function(workout) {
    var date = new Date();
    date.setDate(date.getDate()+5);
    var dd = date.getDate();
    var mm = date.getMonth()+1;
    var yyyy = date.getFullYear();
    if (mm < 10) {mm = '0'+mm};
    if (dd < 10) {dd = '0'+dd};
    var sixthdayDate = yyyy+'-'+mm+'-'+dd;

    if(workout.date === sixthdayDate) { return true };
  },
  seventhday: function(workout) {
    var date = new Date();
    date.setDate(date.getDate()+6);
    var dd = date.getDate();
    var mm = date.getMonth()+1;
    var yyyy = date.getFullYear();
    if (mm < 10) {mm = '0'+mm};
    if (dd < 10) {dd = '0'+dd};
    var seventhdayDate = yyyy+'-'+mm+'-'+dd;

    if(workout.date === seventhdayDate) { return true };
  },

  //Next week
  sw_today: function(workout) {
    var date = new Date();
    date.setDate(date.getDate()+7);
    var dd = date.getDate();
    var mm = date.getMonth()+1;
    var yyyy = date.getFullYear();
    if (mm < 10) {mm = '0'+mm};
    if (dd < 10) {dd = '0'+dd};
    var sw_todaysDate = yyyy+'-'+mm+'-'+dd;

    if(workout.date === sw_todaysDate) { return true }
  },
  sw_tomorrow: function(workout) {
    var date = new Date();
    date.setDate(date.getDate()+8);
    var dd = date.getDate();
    var mm = date.getMonth()+1;
    var yyyy = date.getFullYear();
    if (mm < 10) {mm = '0'+mm};
    if (dd < 10) {dd = '0'+dd};
    var sw_tomorrowsDate = yyyy+'-'+mm+'-'+dd;

    if(workout.date === sw_tomorrowsDate) { return true };
  },
  sw_thirdday: function(workout) {
    var date = new Date();
    date.setDate(date.getDate()+9);
    var dd = date.getDate();
    var mm = date.getMonth()+1;
    var yyyy = date.getFullYear();
    if (mm < 10) {mm = '0'+mm};
    if (dd < 10) {dd = '0'+dd};
    var sw_thirddayDate = yyyy+'-'+mm+'-'+dd;

    if(workout.date === sw_thirddayDate) { return true };
  },
  sw_fourthday: function(workout) {
    var date = new Date();
    date.setDate(date.getDate()+10);
    var dd = date.getDate();
    var mm = date.getMonth()+1;
    var yyyy = date.getFullYear();
    if (mm < 10) {mm = '0'+mm};
    if (dd < 10) {dd = '0'+dd};
    var sw_fourthdayDate = yyyy+'-'+mm+'-'+dd;

    if(workout.date === sw_fourthdayDate) { return true };
  },
  sw_fifthday: function(workout) {
    var date = new Date();
    date.setDate(date.getDate()+11);
    var dd = date.getDate();
    var mm = date.getMonth()+1;
    var yyyy = date.getFullYear();
    if (mm < 10) {mm = '0'+mm};
    if (dd < 10) {dd = '0'+dd};
    var sw_fifthdayDate = yyyy+'-'+mm+'-'+dd;

    if(workout.date === sw_fifthdayDate) { return true };
  },
  sw_sixthday: function(workout) {
    var date = new Date();
    date.setDate(date.getDate()+12);
    var dd = date.getDate();
    var mm = date.getMonth()+1;
    var yyyy = date.getFullYear();
    if (mm < 10) {mm = '0'+mm};
    if (dd < 10) {dd = '0'+dd};
    var sw_sixthdayDate = yyyy+'-'+mm+'-'+dd;

    if(workout.date === sw_sixthdayDate) { return true };
  },
  sw_seventhday: function(workout) {
    var date = new Date();
    date.setDate(date.getDate()+13);
    var dd = date.getDate();
    var mm = date.getMonth()+1;
    var yyyy = date.getFullYear();
    if (mm < 10) {mm = '0'+mm};
    if (dd < 10) {dd = '0'+dd};
    var sw_seventhdayDate = yyyy+'-'+mm+'-'+dd;

    if(workout.date === sw_seventhdayDate) { return true };
  },


  //Third week
  tw_today: function(workout) {
    var date = new Date();
    date.setDate(date.getDate()+14);
    var dd = date.getDate();
    var mm = date.getMonth()+1;
    var yyyy = date.getFullYear();
    if (mm < 10) {mm = '0'+mm};
    if (dd < 10) {dd = '0'+dd};
    var tw_todaysDate = yyyy+'-'+mm+'-'+dd;

    if(workout.date === tw_todaysDate) { return true };
  },
  tw_tomorrow: function(workout) {
    var date = new Date();
    date.setDate(date.getDate()+15);
    var dd = date.getDate();
    var mm = date.getMonth()+1;
    var yyyy = date.getFullYear();
    if (mm < 10) {mm = '0'+mm};
    if (dd < 10) {dd = '0'+dd};
    var tw_tomorrowsDate = yyyy+'-'+mm+'-'+dd;

    if(workout.date === tw_tomorrowsDate) { return true };
  },
  tw_thirdday: function(workout) {
    var date = new Date();
    date.setDate(date.getDate()+16);
    var dd = date.getDate();
    var mm = date.getMonth()+1;
    var yyyy = date.getFullYear();
    if (mm < 10) {mm = '0'+mm};
    if (dd < 10) {dd = '0'+dd};
    var tw_thirddayDate = yyyy+'-'+mm+'-'+dd;

    if(workout.date === tw_thirddayDate) { return true };
  },
  tw_fourthday: function(workout) {
    var date = new Date();
    date.setDate(date.getDate()+17);
    var dd = date.getDate();
    var mm = date.getMonth()+1;
    var yyyy = date.getFullYear();
    if (mm < 10) {mm = '0'+mm};
    if (dd < 10) {dd = '0'+dd};
    var tw_fourthdayDate = yyyy+'-'+mm+'-'+dd;

    if(workout.date === tw_fourthdayDate) { return true };
  },
  tw_fifthday: function(workout) {
    var date = new Date();
    date.setDate(date.getDate()+18);
    var dd = date.getDate();
    var mm = date.getMonth()+1;
    var yyyy = date.getFullYear();
    if (mm < 10) {mm = '0'+mm};
    if (dd < 10) {dd = '0'+dd};
    var tw_fifthdayDate = yyyy+'-'+mm+'-'+dd;

    if(workout.date === tw_fifthdayDate) { return true };
  },
  tw_sixthday: function(workout) {
    var date = new Date();
    date.setDate(date.getDate()+19);
    var dd = date.getDate();
    var mm = date.getMonth()+1;
    var yyyy = date.getFullYear();
    if (mm < 10) {mm = '0'+mm};
    if (dd < 10) {dd = '0'+dd};
    var tw_sixthdayDate = yyyy+'-'+mm+'-'+dd;

    if(workout.date === tw_sixthdayDate) { return true };
  },
  tw_seventhday: function(workout) {
    var date = new Date();
    date.setDate(date.getDate()+20);
    var dd = date.getDate();
    var mm = date.getMonth()+1;
    var yyyy = date.getFullYear();
    if (mm < 10) {mm = '0'+mm};
    if (dd < 10) {dd = '0'+dd};
    var tw_seventhdayDate = yyyy+'-'+mm+'-'+dd;

    if(workout.date === tw_seventhdayDate) { return true };
  },

  //Fourth week
  fw_today: function(workout) {
    var date = new Date();
    date.setDate(date.getDate()+21);
    var dd = date.getDate();
    var mm = date.getMonth()+1;
    var yyyy = date.getFullYear();
    if (mm < 10) {mm = '0'+mm};
    if (dd < 10) {dd = '0'+dd};
    var fw_todaysDate = yyyy+'-'+mm+'-'+dd;

    if(workout.date === fw_todaysDate) { return true };
  },
  fw_tomorrow: function(workout) {
    var date = new Date();
    date.setDate(date.getDate()+22);
    var dd = date.getDate();
    var mm = date.getMonth()+1;
    var yyyy = date.getFullYear();
    if (mm < 10) {mm = '0'+mm};
    if (dd < 10) {dd = '0'+dd};
    var fw_tomorrowsDate = yyyy+'-'+mm+'-'+dd;

    if(workout.date === fw_tomorrowsDate) { return true };
  },
  fw_thirdday: function(workout) {
    var date = new Date();
    date.setDate(date.getDate()+23);
    var dd = date.getDate();
    var mm = date.getMonth()+1;
    var yyyy = date.getFullYear();
    if (mm < 10) {mm = '0'+mm};
    if (dd < 10) {dd = '0'+dd};
    var fw_thirddayDate = yyyy+'-'+mm+'-'+dd;

    if(workout.date === fw_thirddayDate) { return true };
  },
  fw_fourthday: function(workout) {
    var date = new Date();
    date.setDate(date.getDate()+24);
    var dd = date.getDate();
    var mm = date.getMonth()+1;
    var yyyy = date.getFullYear();
    if (mm < 10) {mm = '0'+mm};
    if (dd < 10) {dd = '0'+dd};
    var fw_fourthdayDate = yyyy+'-'+mm+'-'+dd;

    if(workout.date === fw_fourthdayDate) { return true };
  },
  fw_fifthday: function(workout) {
    var date = new Date();
    date.setDate(date.getDate()+25);
    var dd = date.getDate();
    var mm = date.getMonth()+1;
    var yyyy = date.getFullYear();
    if (mm < 10) {mm = '0'+mm};
    if (dd < 10) {dd = '0'+dd};
    var fw_fifthdayDate = yyyy+'-'+mm+'-'+dd;

    if(workout.date === fw_fifthdayDate) { return true };
  },
  fw_sixthday: function(workout) {
    var date = new Date();
    date.setDate(date.getDate()+26);
    var dd = date.getDate();
    var mm = date.getMonth()+1;
    var yyyy = date.getFullYear();
    if (mm < 10) {mm = '0'+mm};
    if (dd < 10) {dd = '0'+dd};
    var fw_sixthdayDate = yyyy+'-'+mm+'-'+dd;

    if(workout.date === fw_sixthdayDate) { return true };
  },
  fw_seventhday: function(workout) {
    var date = new Date();
    date.setDate(date.getDate()+27);
    var dd = date.getDate();
    var mm = date.getMonth()+1;
    var yyyy = date.getFullYear();
    if (mm < 10) {mm = '0'+mm};
    if (dd < 10) {dd = '0'+dd};
    var fw_seventhdayDate = yyyy+'-'+mm+'-'+dd;

    if(workout.date === fw_seventhdayDate) { return true };
  },


  //Date functions
  todayDate: function() {
    var date = new Date();
    var dd = date.getDate();
    var mm = date.getMonth()+1;
    var yyyy = date.getFullYear();
    if (mm < 10) {mm = '0'+mm};
    if (dd < 10) {dd = '0'+dd};
    var todaysDate = yyyy+'-'+mm+'-'+dd;
    this.activeDate = todaysDate;

    if(this.activeDate === todaysDate) { return true };
  },

  isActive: function(type) {
    return this.activeType === type
  },
  setActive: function (type) {
    this.activeType = type;
    if (this.activeType === 'all') {
      this.dropdownTypeName = 'Velg trening'
    } else { this.dropdownTypeName = this.activeType };
  },
  isActiveDay: function (weekday) {
    return this.activeDay === weekday
  },
  setActiveDay: function (day) {
    this.activeDay = day
  }
},

created() {

  var db = Firebase.database();

  if (Firebase.auth().currentUser != null) {this.currentUserId = Firebase.auth().currentUser.uid};


  Firebase.database().ref('workouts/').on('value', snapshot => {
           this.test_workouts = snapshot.val();
         });
  if (Firebase.auth().currentUser != null) {var currentUserId = Firebase.auth().currentUser.uid};
  Firebase.database().ref('users/'+currentUserId+'/workoutsAttended').on('value', snapshot => {
           this.user_workouts = snapshot.val();
        });

  //Todays date and days for whole row
  var date = new Date();
  var dd = date.getDate();
  var thisday = date.getDay();

  if (thisday === 1) { this.day = 'Mandag'; this.dayTomorrow = 'Tirsdag'; this.dayThirdday = 'Onsdag'; this.dayFourthday = 'Torsdag'; this.dayFifthday = 'Fredag'; this.daySixthday = 'Lørdag'; this.daySeventhday = 'Søndag' }
  else if (thisday === 2) { this.day = 'Tirsdag'; this.dayTomorrow = 'Onsdag'; this.dayThirdday = 'Torsdag'; this.dayFourthday = 'Fredag'; this.dayFifthday = 'Lørdag'; this.daySixthday = 'Søndag'; this.daySeventhday = 'Mandag' }
  else if (thisday === 3) { this.day = 'Onsdag'; this.dayTomorrow = 'Torsdag'; this.dayThirdday = 'Fredag'; this.dayFourthday = 'Lørdag'; this.dayFifthday = 'Søndag'; this.daySixthday = 'Mandag'; this.daySeventhday = 'Tirsdag' }
  else if (thisday === 4) { this.day = 'Torsdag'; this.dayTomorrow = 'Fredag'; this.dayThirdday = 'Lørdag'; this.dayFourthday = 'Søndag'; this.dayFifthday = 'Mandag'; this.daySixthday = 'Tirsdag'; this.daySeventhday = 'Onsdag' }
  else if (thisday === 5) { this.day = 'Fredag'; this.dayTomorrow = 'Lørdag'; this.dayThirdday = 'Søndag'; this.dayFourthday = 'Mandag'; this.dayFifthday = 'Tirsdag'; this.daySixthday = 'Onsdag'; this.daySeventhday = 'Torsdag' }
  else if (thisday === 6) { this.day = 'Lørdag'; this.dayTomorrow = 'Søndag'; this.dayThirdday = 'Mandag'; this.dayFourthday = 'Tirsdag'; this.dayFifthday = 'Onsdag'; this.daySixthday = 'Torsdag'; this.daySeventhday = 'Fredag' }
  else if (thisday === 0) { this.day = 'Søndag'; this.dayTomorrow = 'Mandag'; this.dayThirdday = 'Tirsdag'; this.dayFourthday = 'Onsdag'; this.dayFifthday = 'Torsdag'; this.daySixthday = 'Fredag'; this.daySeventhday = 'Lørdag' };

  var mm = date.getMonth()+1;

  this.dateNumber = dd+'.'+mm;
  //Tomorrows date showed in table
  var to = new Date();
  to.setDate(to.getDate()+1);
  var tomorrow_dd = to.getDate();
  var tomorrow_mm = to.getMonth()+1;
  var tomorrowsDateNumber = tomorrow_dd+'.'+tomorrow_mm;
  this.dateNumberTomorrow = tomorrowsDateNumber;
  //Third days date showed in table
  var th = new Date();
  th.setDate(th.getDate()+2);
  var th_dd = th.getDate();
  var th_mm = th.getMonth()+1;
  var thDateNumber = th_dd+'.'+th_mm;
  this.dateNumberThirdday = thDateNumber;
  //Fourth days date showed in table
  var fh = new Date();
  fh.setDate(fh.getDate()+3);
  var fh_dd = fh.getDate();
  var fh_mm = fh.getMonth()+1;
  var fhDateNumber = fh_dd+'.'+fh_mm;
  this.dateNumberFourthday = fhDateNumber;
  //Fifth date showed in table
  var fi = new Date();
  fi.setDate(fi.getDate()+4);
  var fi_dd = fi.getDate();
  var fi_mm = fi.getMonth()+1;
  var fiDateNumber = fi_dd+'.'+fi_mm;
  this.dateNumberFifthday = fiDateNumber;
  //Sixth date showed in table
  var si = new Date();
  si.setDate(si.getDate()+5);
  var si_dd = si.getDate();
  var si_mm = si.getMonth()+1;
  var siDateNumber = si_dd+'.'+si_mm;
  this.dateNumberSixthday = siDateNumber;

  var sev = new Date();
  sev.setDate(sev.getDate()+6);
  var sev_dd = sev.getDate();
  var sev_mm = sev.getMonth()+1;
  var sevDateNumber = sev_dd+'.'+sev_mm;
  this.dateNumberSeventhday = sevDateNumber;

  //Next week and next weeks days
  //Todays date and days for whole row
  var sw_date = new Date();
  sw_date.setDate(sw_date.getDate()+7);
  var sw_dd = sw_date.getDate();
  var sw_thisday = sw_date.getDay();

  if (sw_thisday === 1) { this.sw_day = 'Mandag'; this.sw_dayTomorrow = 'Tirsdag'; this.sw_dayThirdday = 'Onsdag'; this.sw_dayFourthday = 'Torsdag'; this.sw_dayFifthday = 'Fredag'; this.sw_daySixthday = 'Lørdag'; this.sw_daySeventhday = 'Søndag' }
  else if (sw_thisday === 2) { this.sw_day = 'Tirsdag'; this.sw_dayTomorrow = 'Onsdag'; this.sw_dayThirdday = 'Torsdag'; this.sw_dayFourthday = 'Fredag'; this.sw_dayFifthday = 'Lørdag'; this.sw_daySixthday = 'Søndag'; this.sw_daySeventhday = 'Mandag' }
  else if (sw_thisday === 3) { this.sw_day = 'Onsdag'; this.sw_dayTomorrow = 'Torsdag'; this.sw_dayThirdday = 'Fredag'; this.sw_dayFourthday = 'Lørdag'; this.sw_dayFifthday = 'Søndag'; this.sw_daySixthday = 'Mandag'; this.sw_daySeventhday = 'Tirsdag' }
  else if (sw_thisday === 4) { this.sw_day = 'Torsdag'; this.sw_dayTomorrow = 'Fredag'; this.sw_dayThirdday = 'Lørdag'; this.sw_dayFourthday = 'Søndag'; this.sw_dayFifthday = 'Mandag'; this.sw_daySixthday = 'Tirsdag'; this.sw_daySeventhday = 'Onsdag' }
  else if (sw_thisday === 5) { this.sw_day = 'Fredag'; this.sw_dayTomorrow = 'Lørdag'; this.sw_dayThirdday = 'Søndag'; this.sw_dayFourthday = 'Mandag'; this.sw_dayFifthday = 'Tirsdag'; this.sw_daySixthday = 'Onsdag'; this.sw_daySeventhday = 'Torsdag' }
  else if (sw_thisday === 6) { this.sw_day = 'Lørdag'; this.sw_dayTomorrow = 'Søndag'; this.sw_dayThirdday = 'Mandag'; this.sw_dayFourthday = 'Tirsdag'; this.sw_dayFifthday = 'Onsdag'; this.sw_daySixthday = 'Torsdag'; this.sw_daySeventhday = 'Fredag' }
  else if (sw_thisday === 0) { this.sw_day = 'Søndag'; this.sw_dayTomorrow = 'Mandag'; this.sw_dayThirdday = 'Tirsdag'; this.sw_dayFourthday = 'Onsdag'; this.sw_dayFifthday = 'Torsdag'; this.sw_daySixthday = 'Fredag'; this.sw_daySeventhday = 'Lørdag' };

  var sw_mm = sw_date.getMonth()+1;

  this.sw_dateNumber = sw_dd+'.'+sw_mm;
  //Tomorrows date showed in table
  var sw_to = new Date();
  sw_to.setDate(sw_to.getDate()+8);
  var sw_tomorrow_dd = sw_to.getDate();
  var sw_tomorrow_mm = sw_to.getMonth()+1;
  var sw_tomorrowsDateNumber = sw_tomorrow_dd+'.'+sw_tomorrow_mm;
  this.sw_dateNumberTomorrow = sw_tomorrowsDateNumber;
  //Third days date showed in table
  var sw_th = new Date();
  sw_th.setDate(sw_th.getDate()+9);
  var sw_th_dd = sw_th.getDate();
  var sw_th_mm = sw_th.getMonth()+1;
  var sw_thDateNumber = sw_th_dd+'.'+sw_th_mm;
  this.sw_dateNumberThirdday = sw_thDateNumber;
  //Fourth days date showed in table
  var sw_fh = new Date();
  sw_fh.setDate(sw_fh.getDate()+10);
  var sw_fh_dd = sw_fh.getDate();
  var sw_fh_mm = sw_fh.getMonth()+1;
  var sw_fhDateNumber = sw_fh_dd+'.'+sw_fh_mm;
  this.sw_dateNumberFourthday = sw_fhDateNumber;
  //Fifth date showed in table
  var sw_fi = new Date();
  sw_fi.setDate(sw_fi.getDate()+11);
  var sw_fi_dd = sw_fi.getDate();
  var sw_fi_mm = sw_fi.getMonth()+1;
  var sw_fiDateNumber = sw_fi_dd+'.'+sw_fi_mm;
  this.sw_dateNumberFifthday = sw_fiDateNumber;
  //Sixth date showed in table
  var sw_si = new Date();
  sw_si.setDate(sw_si.getDate()+12);
  var sw_si_dd = sw_si.getDate();
  var sw_si_mm = sw_si.getMonth()+1;
  var sw_siDateNumber = sw_si_dd+'.'+sw_si_mm;
  this.sw_dateNumberSixthday = sw_siDateNumber;
  //Seventh date showed in table
  var sw_sev = new Date();
  sw_sev.setDate(sw_sev.getDate()+13);
  var sw_sev_dd = sw_sev.getDate();
  var sw_sev_mm = sw_sev.getMonth()+1;
  var sw_sevDateNumber = sw_sev_dd+'.'+sw_sev_mm;
  this.sw_dateNumberSeventhday = sw_sevDateNumber;

  //THIRD week and next weeks days
  //Todays date and days for whole row
  var tw_date = new Date();
  tw_date.setDate(tw_date.getDate()+14);
  var tw_dd = tw_date.getDate();
  var tw_thisday = tw_date.getDay();

  if (tw_thisday === 1) { this.tw_day = 'Mandag'; this.tw_dayTomorrow = 'Tirsdag'; this.tw_dayThirdday = 'Onsdag'; this.tw_dayFourthday = 'Torsdag'; this.tw_dayFifthday = 'Fredag'; this.tw_daySixthday = 'Lørdag'; this.tw_daySeventhday = 'Søndag' }
  else if (tw_thisday === 2) { this.tw_day = 'Tirsdag'; this.tw_dayTomorrow = 'Onsdag'; this.tw_dayThirdday = 'Torsdag'; this.tw_dayFourthday = 'Fredag'; this.tw_dayFifthday = 'Lørdag'; this.tw_daySixthday = 'Søndag'; this.tw_daySeventhday = 'Mandag' }
  else if (tw_thisday === 3) { this.tw_day = 'Onsdag'; this.tw_dayTomorrow = 'Torsdag'; this.tw_dayThirdday = 'Fredag'; this.tw_dayFourthday = 'Lørdag'; this.tw_dayFifthday = 'Søndag'; this.tw_daySixthday = 'Mandag'; this.tw_daySeventhday = 'Tirsdag' }
  else if (tw_thisday === 4) { this.tw_day = 'Torsdag'; this.tw_dayTomorrow = 'Fredag'; this.tw_dayThirdday = 'Lørdag'; this.tw_dayFourthday = 'Søndag'; this.tw_dayFifthday = 'Mandag'; this.tw_daySixthday = 'Tirsdag'; this.tw_daySeventhday = 'Onsdag' }
  else if (tw_thisday === 5) { this.tw_day = 'Fredag'; this.tw_dayTomorrow = 'Lørdag'; this.tw_dayThirdday = 'Søndag'; this.tw_dayFourthday = 'Mandag'; this.tw_dayFifthday = 'Tirsdag'; this.tw_daySixthday = 'Onsdag'; this.tw_daySeventhday = 'Torsdag' }
  else if (tw_thisday === 6) { this.tw_day = 'Lørdag'; this.tw_dayTomorrow = 'Søndag'; this.tw_dayThirdday = 'Mandag'; this.tw_dayFourthday = 'Tirsdag'; this.tw_dayFifthday = 'Onsdag'; this.tw_daySixthday = 'Torsdag'; this.tw_daySeventhday = 'Fredag' }
  else if (tw_thisday === 0) { this.tw_day = 'Søndag'; this.tw_dayTomorrow = 'Mandag'; this.tw_dayThirdday = 'Tirsdag'; this.tw_dayFourthday = 'Onsdag'; this.tw_dayFifthday = 'Torsdag'; this.tw_daySixthday = 'Fredag'; this.tw_daySeventhday = 'Lørdag' };

  var tw_mm = tw_date.getMonth()+1;

  this.tw_dateNumber = tw_dd+'.'+tw_mm;
  //Tomorrows date showed in table
  var tw_to = new Date();
  tw_to.setDate(tw_to.getDate()+15);
  var tw_tomorrow_dd = tw_to.getDate();
  var tw_tomorrow_mm = tw_to.getMonth()+1;
  var tw_tomorrowsDateNumber = tw_tomorrow_dd+'.'+tw_tomorrow_mm;
  this.tw_dateNumberTomorrow = tw_tomorrowsDateNumber;
  //Third days date showed in table
  var tw_th = new Date();
  tw_th.setDate(tw_th.getDate()+16);
  var tw_th_dd = tw_th.getDate();
  var tw_th_mm = tw_th.getMonth()+1;
  var tw_thDateNumber = tw_th_dd+'.'+tw_th_mm;
  this.tw_dateNumberThirdday = tw_thDateNumber;
  //Fourth days date showed in table
  var tw_fh = new Date();
  tw_fh.setDate(tw_fh.getDate()+17);
  var tw_fh_dd = tw_fh.getDate();
  var tw_fh_mm = tw_fh.getMonth()+1;
  var tw_fhDateNumber = tw_fh_dd+'.'+tw_fh_mm;
  this.tw_dateNumberFourthday = tw_fhDateNumber;
  //Fifth date showed in table
  var tw_fi = new Date();
  tw_fi.setDate(tw_fi.getDate()+18);
  var tw_fi_dd = tw_fi.getDate();
  var tw_fi_mm = tw_fi.getMonth()+1;
  var tw_fiDateNumber = tw_fi_dd+'.'+tw_fi_mm;
  this.tw_dateNumberFifthday = tw_fiDateNumber;
  //Sixth date showed in table
  var tw_si = new Date();
  tw_si.setDate(tw_si.getDate()+19);
  var tw_si_dd = tw_si.getDate();
  var tw_si_mm = tw_si.getMonth()+1;
  var tw_siDateNumber = tw_si_dd+'.'+tw_si_mm;
  this.tw_dateNumberSixthday = tw_siDateNumber;
  //Seventh date showed in table
  var tw_sev = new Date();
  tw_sev.setDate(tw_sev.getDate()+20);
  var tw_sev_dd = tw_sev.getDate();
  var tw_sev_mm = tw_sev.getMonth()+1;
  var tw_sevDateNumber = tw_sev_dd+'.'+tw_sev_mm;
  this.tw_dateNumberSeventhday = tw_sevDateNumber;

  //FOURTH week and next weeks days
  //Todays date and days for whole row
  var fw_date = new Date();
  fw_date.setDate(fw_date.getDate()+21);
  var fw_dd = fw_date.getDate();
  var fw_thisday = fw_date.getDay();

  if (fw_thisday === 1) { this.fw_day = 'Mandag'; this.fw_dayTomorrow = 'Tirsdag'; this.fw_dayThirdday = 'Onsdag'; this.fw_dayFourthday = 'Torsdag'; this.fw_dayFifthday = 'Fredag'; this.fw_daySixthday = 'Lørdag'; this.fw_daySeventhday = 'Søndag' }
  else if (fw_thisday === 2) { this.fw_day = 'Tirsdag'; this.fw_dayTomorrow = 'Onsdag'; this.fw_dayThirdday = 'Torsdag'; this.fw_dayFourthday = 'Fredag'; this.fw_dayFifthday = 'Lørdag'; this.fw_daySixthday = 'Søndag'; this.fw_daySeventhday = 'Mandag' }
  else if (fw_thisday === 3) { this.fw_day = 'Onsdag'; this.fw_dayTomorrow = 'Torsdag'; this.fw_dayThirdday = 'Fredag'; this.fw_dayFourthday = 'Lørdag'; this.fw_dayFifthday = 'Søndag'; this.fw_daySixthday = 'Mandag'; this.fw_daySeventhday = 'Tirsdag' }
  else if (fw_thisday === 4) { this.fw_day = 'Torsdag'; this.fw_dayTomorrow = 'Fredag'; this.fw_dayThirdday = 'Lørdag'; this.fw_dayFourthday = 'Søndag'; this.fw_dayFifthday = 'Mandag'; this.fw_daySixthday = 'Tirsdag'; this.fw_daySeventhday = 'Onsdag' }
  else if (fw_thisday === 5) { this.fw_day = 'Fredag'; this.fw_dayTomorrow = 'Lørdag'; this.fw_dayThirdday = 'Søndag'; this.fw_dayFourthday = 'Mandag'; this.fw_dayFifthday = 'Tirsdag'; this.fw_daySixthday = 'Onsdag'; this.fw_daySeventhday = 'Torsdag' }
  else if (fw_thisday === 6) { this.fw_day = 'Lørdag'; this.fw_dayTomorrow = 'Søndag'; this.fw_dayThirdday = 'Mandag'; this.fw_dayFourthday = 'Tirsdag'; this.fw_dayFifthday = 'Onsdag'; this.fw_daySixthday = 'Torsdag'; this.fw_daySeventhday = 'Fredag' }
  else if (fw_thisday === 0) { this.fw_day = 'Søndag'; this.fw_dayTomorrow = 'Mandag'; this.fw_dayThirdday = 'Tirsdag'; this.fw_dayFourthday = 'Onsdag'; this.fw_dayFifthday = 'Torsdag'; this.fw_daySixthday = 'Fredag'; this.fw_daySeventhday = 'Lørdag' };

  var fw_mm = fw_date.getMonth()+1;

  this.fw_dateNumber = fw_dd+'.'+fw_mm;
  //Tomorrows date showed in table
  var fw_to = new Date();
  fw_to.setDate(fw_to.getDate()+22);
  var fw_tomorrow_dd = fw_to.getDate();
  var fw_tomorrow_mm = fw_to.getMonth()+1;
  var fw_tomorrowsDateNumber = fw_tomorrow_dd+'.'+fw_tomorrow_mm;
  this.fw_dateNumberTomorrow = fw_tomorrowsDateNumber;
  //Third days date showed in table
  var fw_th = new Date();
  fw_th.setDate(fw_th.getDate()+23);
  var fw_th_dd = fw_th.getDate();
  var fw_th_mm = fw_th.getMonth()+1;
  var fw_thDateNumber = fw_th_dd+'.'+fw_th_mm;
  this.fw_dateNumberThirdday = fw_thDateNumber;
  //Fourth days date showed in table
  var fw_fh = new Date();
  fw_fh.setDate(fw_fh.getDate()+24);
  var fw_fh_dd = fw_fh.getDate();
  var fw_fh_mm = fw_fh.getMonth()+1;
  var fw_fhDateNumber = fw_fh_dd+'.'+fw_fh_mm;
  this.fw_dateNumberFourthday = fw_fhDateNumber;
  //Fifth date showed in table
  var fw_fi = new Date();
  fw_fi.setDate(fw_fi.getDate()+25);
  var fw_fi_dd = fw_fi.getDate();
  var fw_fi_mm = fw_fi.getMonth()+1;
  var fw_fiDateNumber = fw_fi_dd+'.'+fw_fi_mm;
  this.fw_dateNumberFifthday = fw_fiDateNumber;
  //Sixth date showed in table
  var fw_si = new Date();
  fw_si.setDate(fw_si.getDate()+26);
  var fw_si_dd = fw_si.getDate();
  var fw_si_mm = fw_si.getMonth()+1;
  var fw_siDateNumber = fw_si_dd+'.'+fw_si_mm;
  this.fw_dateNumberSixthday = fw_siDateNumber;
  //Seventh date showed in table
  var fw_sev = new Date();
  fw_sev.setDate(fw_sev.getDate()+27);
  var fw_sev_dd = fw_sev.getDate();
  var fw_sev_mm = fw_sev.getMonth()+1;
  var fw_sevDateNumber = fw_sev_dd+'.'+fw_sev_mm;
  this.fw_dateNumberSeventhday = fw_sevDateNumber;

},
computed: {
  workouts_sorted_time: function() {
    return _.orderBy(this.test_workouts, 'time')
  },
  workouts_sorted_type: function() {
    return _.orderBy(this.workouts, 'type')
  }
},
filters: {
  formatDate: function (date) {
    var day = date[8]+date[9];
    var month = date[5]+date[6];
    return day+'/'+month;
  }
}

}

</script>


<style>

@media screen and (max-width: 768px) {

  .about {
    padding-top: 80px;
    background-color: #F5F7F9;
    font-family: 'Lato', sans-serif;
  }

  .workout-image{
    transform: scale(0.9);
  }

  li{
    font-size: 12px;
  }

  .column.cities {
    width: 100px;
  }

  div.column.is-one-quarter.classes {
    box-shadow: 0px 8px 18px rgba(0, 0, 0, 0.05);
    border-radius: 6px;
    width: 200px;
  }
  div.column.is-one-quarter.classes:hover {
    box-shadow: 0px 9px 24px rgba(0, 0, 0, 0.10);
    transition: all 0.3s
  }

  div.container.taster-cities{
    margin-right: 500px;
    margin-left: 500px;
    width: 600px;
  }
  div.tabs.taster-cities{
    width: 600px;
  }

  #classes.container.taster-dates{
    max-width: 1000px;
  }

  .workout-type {
    font-size: 1rem;
    border-radius: 0px;

  }

  .workout-type.is-active {
    border-width: 8px;
    border-color: #15C0BA;
    justify-content: center;
    text-align: center;
  }
  .workout-type.is-active:hover {
    border-width: 9px;
    border-color: #15C0BA;
  }
  .workout-type:hover {
    border-width: 3px;
    border-color: #15C0BA;
    transition: 0.2s;
  }

  .workout-date.is-active {
    font-family: 'Helvetica Neue';
    color: #15C0BA;
  }
  .workout-date {
    font-family: 'Helvetica Neue';
    font-size: 1rem;
  }

  #explore-container{
    padding-right: 10px;
    margin-bottom: 20px;
    width: 320px;
    background-color: white;
    box-shadow: 8px 8px 20px rgba(0, 0, 0, 0.02);
  }

  #workout-time{
    max-width:100px;
    color: #3a3a3a;
    font-size: 0.8rem;
    padding-bottom: 0px;
  }

  #workout-studio{
    color: #3a3a3a;
    font-size: 0.8rem;
    font-family: 'Lato';
    max-width: 200px;
    padding-bottom: 0px;
  }

  #workout-duration{
    max-width: 90px;
    color: #3a3a3a;
    font-size: 0.8rem;
    padding-bottom: 0px;
  }
  #workout-name-td{
    width: 240px;
  }
  #workout-name{
    font-size: 0.8rem;
    font-family: 'Lato';
    max-width: 240px;
    color: #18253E;
    padding-bottom: 0px;
  }
  #workout-name-a{
    color: #18253E;
  }
  #workout-type {
    color: #3a3a3a;
    font-size: 0.8rem;
    font-family: 'Lato';
    max-width: 120px;
  }
  #workout-places {
    margin-top: 2px;
    color: #3a3a3a;
    font-size: 0.8rem;
    font-family: 'Lato';
    max-width: 150px;
  }
  #workout-time{
    max-width:100px;
  }

  #workout-studio-hd{

    display: none;
  }

  #workout-time-hd{

        display: none;
  }
  #workout-duration-hd{
        display: none;
  }
  #workout-name-hd{
    display: none;
  }
  #workout-type-hd {
    display: none;
  }


  #workout-book{
    max-width: 100px;
  }

  #workout-explore-container{
    padding-top: 40px;
  }

  div.panel-body {
    padding-left: 100px;
    padding-right: 100px;
  }

  #meldon {
    background-color: #15C0BA;
    color: white;
    border-width: 0px;
    border-radius: 1px;
  }
  #pameld {
    width: 97px;
    background-color: #43B3AF;
    color: white;
    border-width: 0px;
    border-radius: 1px;
  }
  #meldon-in-container{
    font-size: 22px;
    width: 300px;
    background-color: #15C0BA;
    color: white;
    border-width: 0px;
    border-radius: 1px;
  }
  #pameld-in-container{
    font-size: 22px;
    width: 310px;
    background-color: #BFBFBF;
    color: white;
    border-width: 0px;
    border-radius: 1px;
  }
  #meldon-in-container:hover{
    background-color: #5AAFAD;

  }
  #workout-book{
    vertical-align: middle;
    margin-top: -4px;
    margin-bottom: 10px;
  }
  #meldon:hover {
    background-color: #5AAFAD;
    color: white;
    border-width: 0px;
    border-radius: 1px;
  }

  .button.search{
    background-color: #15C0BA;
    font-family: 'Helvetica Neue';
  }

  #btn-weeks{
    border-color: transparent;
    color: grey;
    font-size: 14px;
  }

  #explore-block-meta{
    margin: 0 auto;
  }
  #explore-column{
    margin-bottom: 5px;
  }

  hr.explore-divider{
    margin-top: -20px;
    margin-bottom: 15px;
    background-color: transparent;
  }

  #workout-full-info{
    background-color: white;
    padding-left: 10px;
    padding-right: 10px;
    max-width: 1020px;
  }

  .has-facility{
    text-decoration: line-through;
  }

  #what-you-need{
    margin-bottom: 0px;
  }

  #book-btn-in-dropdown{
    text-align: center;
    margin: auto;
  }

  #icon-location{
    color: #AFE7FF;
  }
  #icon-time{
    color: #9A9A9A;
  }
  #icon-duration{
    color: #9A9A9A;
  }
  #bit-of-padding-bottom{
    padding-bottom: 20px;
    font-family: 'Lato';
  }
  #workout-chevron{
    color: grey;
  }
  #workout-explore-dropdown{
    border-radius: 2px;
    font-family: 'Lato';
    box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.03);
  }
  .is-success#workout-explore-dropdown{
    background-color: #15C0BA;
  }
  #explore-dropdown-button-container{
    padding-left: 10px;
  }
  i.fas.fa-chevron-right.workout-chevron-active{
    transform: rotate(90deg);
    transition: 0.3s;
  }

  #dropdown-font{
      font-family: 'Lato';
  }

  #fullt{
    width: 97px;
    background-color: #BFBFBF;
    color: white;
    border-width: 0px;
    border-radius: 1px;
  }

  .unbook-btn{
    max-width: 130px;
  }

}



@media screen and (min-width: 768px) {
.about {
  padding-top: 120px;
  background-color: #F5F7F9;
  height: 1000px;
  font-family: 'Lato', sans-serif;
}

.workout-image{
  transform: scale(0.9);
}

li{
  font-size: 25px;
}

.column.cities {
  width: 100px;
}

div.column.is-one-quarter.classes {
  box-shadow: 0px 8px 18px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  width: 200px;
}
div.column.is-one-quarter.classes:hover {
  box-shadow: 0px 9px 24px rgba(0, 0, 0, 0.10);
  transition: all 0.3s
}

div.container.taster-cities{
  margin-right: 500px;
  margin-left: 500px;
  width: 600px;
}
div.tabs.taster-cities{
  width: 600px;
}

#classes.container.taster-dates{
  max-width: 1000px;
}

.workout-type {
  font-size: 16px;
  border-radius: 0px;

}

.workout-type.is-active {
  border-width: 8px;
  border-color: #15C0BA;
  justify-content: center;
  text-align: center;
}
.workout-type.is-active:hover {
  border-width: 9px;
  border-color: #15C0BA;
}
.workout-type:hover {
  border-width: 3px;
  border-color: #15C0BA;
  transition: 0.2s;
}

.workout-date.is-active {
  font-family: 'Helvetica Neue';
  color: #15C0BA;
}
.workout-date {
  font-family: 'Helvetica Neue';
  font-size: 16px;
}

#explore-container{
  padding-right: 10px;
  margin-bottom: 20px;
  width: 1020px;
  background-color: white;
  box-shadow: 8px 8px 20px rgba(0, 0, 0, 0.02);
}
#explore-container:hover{
  width: 1020px;
  background-color: white;
  color: black;
  transition: 0.25s;
  box-shadow: 10px 10px 25px rgba(0, 0, 0, 0.08);
}


#workout-time{
  max-width:100px;
  color: #3a3a3a;
}

#workout-studio{
  color: #3a3a3a;
  font-size: 16px;
  font-family: 'Lato';
  max-width: 200px;
}

#workout-duration{
  max-width: 90px;
  color: #3a3a3a;
}
#workout-name-td{
  width: 240px;
}
#workout-name{
  font-size: 16px;
  font-family: 'Lato';
  max-width: 240px;
  color: #18253E;
}
#workout-name-a{
  color: #18253E;
}
#workout-type {
  color: #3a3a3a;
  font-size: 15px;
  font-family: 'Lato';
  max-width: 120px;
}
#workout-places {
  margin-top: 2px;
  color: #3a3a3a;
  font-size: 14px;
  font-family: 'Lato';
  max-width: 150px;
}
#workout-time{
  max-width:100px;
}

#workout-studio-hd{
  color: #3a3a3a;
  font-size: 18px;
  font-family: 'Lato';
  max-width: 200px;
  font-weight: bold;
}

#workout-time-hd{
  color: #3a3a3a;
  font-size: 18px;
  font-family: 'Lato';
  max-width: 200px;
  max-width:100px;
  font-weight: bold;
}
#workout-duration-hd{
  color: #3a3a3a;
  font-size: 18px;
  font-family: 'Lato';
  max-width: 200px;
  max-width: 90px;
  font-weight: bold;
}
#workout-name-hd{
  color: #3a3a3a;
  font-size: 18px;
  font-family: 'Lato';
  max-width: 200px;
  max-width: 240px;
  font-weight: bold;
}
#workout-type-hd {
  color: #3a3a3a;
  font-size: 17px;
  font-family: 'Lato';
  max-width: 120px;
  font-weight: bold;
}


#workout-book{
  max-width: 100px;
}

#workout-explore-container{
  padding-top: 40px;
}

div.panel-body {
  padding-left: 100px;
  padding-right: 100px;
}

#meldon {
  background-color: #15C0BA;
  color: white;
  border-width: 0px;
  border-radius: 1px;
}
#pameld {
  width: 97px;
  background-color: #43B3AF;
  color: white;
  border-width: 0px;
  border-radius: 1px;
}
#meldon-in-container{
  font-size: 22px;
  width: 310px;
  background-color: #15C0BA;
  color: white;
  border-width: 0px;
  border-radius: 1px;
}
#pameld-in-container{
  font-size: 22px;
  width: 310px;
  background-color: #BFBFBF;
  color: white;
  border-width: 0px;
  border-radius: 1px;
}
#meldon-in-container:hover{
  background-color: #5AAFAD;

}
#workout-book{
  vertical-align: middle;
  margin-top: -4px;
  margin-bottom: 10px;
}
#meldon:hover {
  background-color: #5AAFAD;
  color: white;
  border-width: 0px;
  border-radius: 1px;
}

.button.search{
  background-color: #15C0BA;
  font-family: 'Helvetica Neue';
}

#btn-weeks{
  border-color: transparent;
  color: grey;
  font-size: 14px;
}

#explore-block-meta{
  margin: 0 auto;
}
#explore-column{
  margin-bottom: 5px;
}

hr.explore-divider{
  margin-top: -20px;
  margin-bottom: 15px;
  background-color: transparent;
}

#workout-full-info{
  background-color: white;
  padding-left: 10px;
  padding-right: 10px;
  max-width: 1020px;
}

.has-facility{
  text-decoration: line-through;
}

#what-you-need{
  margin-bottom: 0px;
}

#book-btn-in-dropdown{
  text-align: center;
  margin: auto;
}

#icon-location{
  color: #AFE7FF;
}
#icon-time{
  color: #9A9A9A;
}
#icon-duration{
  color: #9A9A9A;
}
#bit-of-padding-bottom{
  padding-bottom: 20px;
  font-family: 'Lato';
}
#workout-chevron{
  color: grey;
}
#workout-explore-dropdown{
  border-radius: 2px;
  font-family: 'Lato';
  box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.03);
}
.is-success#workout-explore-dropdown{
  background-color: #15C0BA;
}
#explore-dropdown-button-container{
  padding-left: 10px;
}
i.fas.fa-chevron-right.workout-chevron-active{
  transform: rotate(90deg);
  transition: 0.3s;
}

#dropdown-font{
    font-family: 'Lato';
}

#fullt{
  width: 97px;
  background-color: #BFBFBF;
  color: white;
  border-width: 0px;
  border-radius: 1px;
}
}
</style>



// WEBPACK FOOTER //
// src/components/ExploreWorkouts.vue